import { Collapse, Row, Col, Tooltip, Input, Form } from "antd";
import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { CollapseComponent } from "../../../components/Collapse";
import WorkflowStore from "../../../DataStores/WorkflowStore";
import { inject, observer } from "mobx-react";

import "../../../styles/components.scss";
import { dataSuperior, dataSuperior0 } from "../../../utils/Utils";
import { toJS } from "mobx";
const { Panel } = Collapse;

const WorkflowTreatment = ({ ToolStore, displayAll }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(WorkflowStore.toFormatJson());
  }, [WorkflowStore.data, ToolStore.numbersToTest, ToolStore.conditions]);

  const toGetElement = (first, second) => {
    var element = WorkflowStore.getData()[0]
      .value.filter((a) => a.fieldName == first)[0]
      .value.filter((b) => b.fieldName == second)[0];
    return element;
  };

  const onChange = (first, e) => {
    if (!WorkflowStore.changed[first]) {
      var json = form.getFieldsValue();
      json[first] = parseFloat(e.nativeEvent.data);
      form.setFieldsValue(json);
    }
    const c = { ...WorkflowStore.changed };
    c[first] = true;
    WorkflowStore.setChanged(c);
  };
  const toGetSubElements = (element) => {
    var items = [];

    element.value.forEach((e) => {
      if ((e.display && e.display != -1) || displayAll) {
        items.push(e);
      }
    });
    return items;
  };

  const onBlur = (ev, id) => {
    if (ev.target.value == "") {
      var json = form.getFieldsValue();
      json[id] = WorkflowStore.defaultsValues[id];
      form.setFieldsValue(json);
      const c = { ...WorkflowStore.changed };

      c[id] = false;
      WorkflowStore.setChanged(c);
    }
  };

  const alignerStatisticsElements = () => {
    const averageDuration = toGetElement(
      "alignersStatistics",
      "averageDuration"
    );
    const appointmentsOverTreatment = toGetElement(
      "alignersStatistics",
      "appointmentsOverTreatment"
    );
    const appointementRefinement = toGetElement(
      "alignersStatistics",
      "appointementRefinement"
    );
    const emergencyAppointments = toGetElement(
      "alignersStatistics",
      "emergencyAppointments"
    );
    const averageDurationItems = toGetSubElements(averageDuration);
    const appointmentsOverTreatmentItems = toGetSubElements(
      appointmentsOverTreatment
    );
    const appointementRefinementItems = toGetSubElements(
      appointementRefinement
    );
    const emergencyAppointmentsItems = toGetSubElements(emergencyAppointments);

    if (displayAll) {
      return (
        <Collapse defaultActiveKey={["1"]}>
          <Panel
            header={
              <Row className="dashed" style={{ marginTop: "2vh" }}>
                <span className="roi--second-collapse-title">
                  <FormattedMessage id="alignersStatistics" />
                </span>
              </Row>
            }
            key="1"
          >
            <Row>
              {averageDurationItems.length > 0 && (
                <>
                  <Col xl={10} md={24}>
                    <Row>
                      <Col xl={2} md={2}>
                        <Tooltip
                          color="#EBEBEA"
                          fontFamily="Gotham"
                          fontSize="20px"
                          style={{ textColor: "#6a6e80" }}
                          placement="rightTop"
                          title={
                            <FormattedMessage id="averageDurationTooltip" />
                          }
                        >
                          <img src="/images/icons/bull.svg" />
                        </Tooltip>
                      </Col>
                      <Col md={12} xl={14}>
                        <span
                          className="roi--label-section"
                          style={{ marginTop: "10px" }}
                        >
                          <FormattedMessage id="averageDuration" />
                        </span>
                      </Col>
                    </Row>

                    <>
                      <Row style={{ marginTop: "1vh" }}>
                        <Col xl={2} md={2} />
                        <Col xl={14} md={12}>
                          <span className="roi--label-section roi--border-adults">
                            <FormattedMessage id="adults" />
                          </span>
                        </Col>
                        <Col xl={8} md={6}>
                          <Form.Item
                            name="alignersStatisticsaverageDurationadults"
                            rules={[{ validator: dataSuperior0 }]}
                          >
                            <Input
                              prefix={averageDurationItems[0].prefix}
                              suffix={averageDurationItems[0].suffix}
                              className={
                                !WorkflowStore.changed
                                  .alignersStatisticsaverageDurationadults &&
                                "roi--input-default"
                              }
                              onBlur={(e) =>
                                onBlur(
                                  e,
                                  "alignersStatisticsaverageDurationadults"
                                )
                              }
                              onChange={(e) =>
                                onChange(
                                  "alignersStatisticsaverageDurationadults",
                                  e
                                )
                              }
                              type="number"
                            ></Input>
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row style={{ marginTop: "1vh" }}>
                        <Col xl={2} md={2} />
                        <Col xl={14} md={12}>
                          <span className="roi--label-section roi--border-adults">
                            <FormattedMessage id="teens" />
                          </span>
                        </Col>
                        <Col xl={8} md={6}>
                          <Form.Item
                            name="alignersStatisticsaverageDurationteens"
                            rules={[{ validator: dataSuperior0 }]}
                          >
                            <Input
                              prefix={averageDurationItems[1].prefix}
                              suffix={averageDurationItems[1].suffix}
                              className={
                                !WorkflowStore.changed
                                  .alignersStatisticsaverageDurationteens &&
                                "roi--input-default"
                              }
                              onBlur={(e) =>
                                onBlur(
                                  e,
                                  "alignersStatisticsaverageDurationteens"
                                )
                              }
                              onChange={(e) =>
                                onChange(
                                  "alignersStatisticsaverageDurationteens",
                                  e
                                )
                              }
                              type="number"
                            ></Input>
                          </Form.Item>
                        </Col>
                      </Row>
                    </>
                  </Col>
                  <Col xl={2} md={0} xs={0}></Col>
                </>
              )}
              <>
                <Col xl={10} md={24}>
                  <Row>
                    <Col xl={2} md={2}>
                      <Tooltip
                        color="#EBEBEA"
                        fontFamily="Gotham"
                        fontSize="20px"
                        style={{ textColor: "#6a6e80" }}
                        placement="rightTop"
                        title={
                          <FormattedMessage id="appointmentsOverTreatmentTooltip" />
                        }
                      >
                        <img src="/images/icons/bull.svg" />
                      </Tooltip>
                    </Col>
                    <Col md={12} xl={14}>
                      <span
                        className="roi--label-section"
                        style={{ marginTop: "10px" }}
                      >
                        <FormattedMessage id="appointmentsOverTreatment" />
                      </span>
                    </Col>
                  </Row>

                  <Row style={{ marginTop: "1vh" }}>
                    <Col xl={2} md={2} />
                    <Col xl={14} md={12}>
                      <span className="roi--label-section roi--border-adults">
                        <FormattedMessage id="adults" />
                      </span>
                    </Col>
                    <Col xl={8} md={6}>
                      <Form.Item
                        name="alignersStatisticsappointmentsOverTreatmentadults"
                        rules={[{ validator: dataSuperior0 }]}
                      >
                        <Input
                          prefix={appointmentsOverTreatmentItems[0].prefix}
                          suffix={appointmentsOverTreatmentItems[0].suffix}
                          className={
                            !WorkflowStore.changed
                              .alignersStatisticsappointmentsOverTreatmentadults &&
                            "roi--input-default"
                          }
                          onBlur={(e) =>
                            onBlur(
                              e,
                              "alignersStatisticsappointmentsOverTreatmentadults"
                            )
                          }
                          onChange={(e) =>
                            onChange(
                              "alignersStatisticsappointmentsOverTreatmentadults",
                              e
                            )
                          }
                          type="number"
                        ></Input>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row style={{ marginTop: "1vh" }}>
                    <Col xl={2} md={2} />
                    <Col xl={14} md={12}>
                      <span className="roi--label-section roi--border-adults">
                        <FormattedMessage id="teens" />
                      </span>
                    </Col>
                    <Col xl={8} md={6}>
                      <Form.Item
                        name="alignersStatisticsappointmentsOverTreatmentteens"
                        rules={[{ validator: dataSuperior0 }]}
                      >
                        <Input
                          prefix={appointmentsOverTreatmentItems[1].prefix}
                          suffix={appointmentsOverTreatmentItems[1].suffix}
                          className={
                            !WorkflowStore.changed
                              .alignersStatisticsappointmentsOverTreatmentteens &&
                            "roi--input-default"
                          }
                          onBlur={(e) =>
                            onBlur(
                              e,
                              "alignersStatisticsappointmentsOverTreatmentteens"
                            )
                          }
                          onChange={(e) =>
                            onChange(
                              "alignersStatisticsappointmentsOverTreatmentteens",
                              e
                            )
                          }
                          type="number"
                        ></Input>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
                <Col xl={2} md={0} xs={0}></Col>
              </>
            </Row>
            <Row>
              <>
                <Col xl={10} md={24}>
                  <Row>
                    <Col xl={2} md={2}>
                      <Tooltip
                        color="#EBEBEA"
                        fontFamily="Gotham"
                        fontSize="20px"
                        style={{ textColor: "#6a6e80" }}
                        placement="rightTop"
                        title={
                          <FormattedMessage id="appointementRefinementTooltip" />
                        }
                      >
                        <img src="/images/icons/bull.svg" />
                      </Tooltip>
                    </Col>
                    <Col md={12} xl={14}>
                      <span
                        className="roi--label-section"
                        style={{ marginTop: "10px" }}
                      >
                        <FormattedMessage id="appointementRefinement" />
                      </span>
                    </Col>
                  </Row>

                  <Row style={{ marginTop: "1vh" }}>
                    <Col xl={2} md={2} />
                    <Col xl={14} md={12}>
                      <span className="roi--label-section roi--border-adults">
                        <FormattedMessage id="adults" />
                      </span>
                    </Col>
                    <Col xl={8} md={6}>
                      <Form.Item
                        name="alignersStatisticsappointementRefinementadults"
                        rules={[{ validator: dataSuperior0 }]}
                      >
                        <Input
                          prefix={appointementRefinementItems[0].prefix}
                          suffix={appointementRefinementItems[0].suffix}
                          className={
                            !WorkflowStore.changed
                              .alignersStatisticsappointementRefinementadults &&
                            "roi--input-default"
                          }
                          onBlur={(e) =>
                            onBlur(
                              e,
                              "alignersStatisticsappointementRefinementadults"
                            )
                          }
                          onChange={(e) =>
                            onChange(
                              "alignersStatisticsappointementRefinementadults",
                              e
                            )
                          }
                          type="number"
                        ></Input>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row style={{ marginTop: "1vh" }}>
                    <Col xl={2} md={2} />
                    <Col xl={14} md={12}>
                      <span className="roi--label-section roi--border-adults">
                        <FormattedMessage id="teens" />
                      </span>
                    </Col>
                    <Col xl={8} md={6}>
                      <Form.Item
                        name="alignersStatisticsappointementRefinementteens"
                        rules={[{ validator: dataSuperior0 }]}
                      >
                        <Input
                          prefix={appointementRefinementItems[1].prefix}
                          suffix={appointementRefinementItems[1].suffix}
                          className={
                            !WorkflowStore.changed
                              .alignersStatisticsappointementRefinementteens &&
                            "roi--input-default"
                          }
                          onBlur={(e) =>
                            onBlur(
                              e,
                              "alignersStatisticsappointementRefinementteens"
                            )
                          }
                          onChange={(e) =>
                            onChange(
                              "alignersStatisticsappointementRefinementteens",
                              e
                            )
                          }
                          type="number"
                        ></Input>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
                <Col xl={2} md={0} xs={0}></Col>
              </>

              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={
                        <FormattedMessage id="emergencyAppointmentsTooltip" />
                      }
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="emergencyAppointments" />
                    </span>
                  </Col>
                </Row>

                <Row style={{ marginTop: "1vh" }}>
                  <Col xl={2} md={2} />
                  <Col xl={14} md={12}>
                    <span className="roi--label-section roi--border-adults">
                      <FormattedMessage id="adults" />
                    </span>
                  </Col>
                  <Col xl={8} md={6}>
                    <Form.Item
                      name="alignersStatisticsemergencyAppointmentsadults"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        prefix={emergencyAppointmentsItems[0].prefix}
                        suffix={emergencyAppointmentsItems[0].suffix}
                        className={
                          !WorkflowStore.changed
                            .alignersStatisticsemergencyAppointmentsadults &&
                          "roi--input-default"
                        }
                        onBlur={(e) =>
                          onBlur(
                            e,
                            "alignersStatisticsemergencyAppointmentsadults"
                          )
                        }
                        onChange={(e) =>
                          onChange(
                            "alignersStatisticsemergencyAppointmentsadults",
                            e
                          )
                        }
                        type="number"
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>

                <Row style={{ marginTop: "1vh" }}>
                  <Col xl={2} md={2} />
                  <Col xl={14} md={12}>
                    <span className="roi--label-section roi--border-adults">
                      <FormattedMessage id="teens" />
                    </span>
                  </Col>
                  <Col xl={8} md={6}>
                    <Form.Item
                      name="alignersStatisticsemergencyAppointmentsteens"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        prefix={emergencyAppointmentsItems[1].prefix}
                        suffix={emergencyAppointmentsItems[1].suffix}
                        className={
                          !WorkflowStore.changed
                            .alignersStatisticsemergencyAppointmentsteens &&
                          "roi--input-default"
                        }
                        onBlur={(e) =>
                          onBlur(
                            e,
                            "alignersStatisticsemergencyAppointmentsteens"
                          )
                        }
                        onChange={(e) =>
                          onChange(
                            "alignersStatisticsemergencyAppointmentsteens",
                            e
                          )
                        }
                        type="number"
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xl={2} md={0} xs={0}></Col>
            </Row>{" "}
          </Panel>
        </Collapse>
      );
    }
    if (
      averageDurationItems.length > 0 ||
      appointmentsOverTreatmentItems.length > 0 ||
      appointementRefinementItems.length > 0 ||
      emergencyAppointmentsItems.length > 0
    ) {
      return (
        <Collapse defaultActiveKey={["1"]}>
          <Panel
            header={
              <Row className="dashed" style={{ marginTop: "2vh" }}>
                <span className="roi--second-collapse-title">
                  <FormattedMessage id="alignersStatistics" />
                </span>
              </Row>
            }
            key="1"
          >
            <Row>
              {averageDurationItems.length > 0 && (
                <>
                  <Col xl={10} md={24}>
                    <Row>
                      <Col xl={2} md={2}>
                        <Tooltip
                          color="#EBEBEA"
                          fontFamily="Gotham"
                          fontSize="20px"
                          style={{ textColor: "#6a6e80" }}
                          placement="rightTop"
                          title={
                            <FormattedMessage id="averageDurationTooltip" />
                          }
                        >
                          <img src="/images/icons/bull.svg" />
                        </Tooltip>
                      </Col>
                      <Col md={12} xl={14}>
                        <span
                          className="roi--label-section"
                          style={{ marginTop: "10px" }}
                        >
                          <FormattedMessage id="averageDuration" />
                        </span>
                      </Col>
                      {averageDurationItems.length == 1 &&
                        averageDurationItems[0].fieldName == "adults" &&
                        ToolStore.numbersToTest.w24 > 0 && (
                          <Col md={6} xl={8}>
                            <Form.Item
                              name="alignersStatisticsaverageDurationadults"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                type="number"
                                suffix={
                                  averageDurationItems[0].suffix &&
                                  averageDurationItems[0].suffix
                                }
                                prefix={
                                  averageDurationItems[0].prefix &&
                                  averageDurationItems[0].prefix
                                }
                                className={
                                  !WorkflowStore.changed
                                    .alignersStatisticsaverageDurationadults &&
                                  "roi--input-default"
                                }
                                onChange={(e) =>
                                  onChange(
                                    "alignersStatisticsaverageDurationadults",
                                    e
                                  )
                                }
                                onBlur={(e) =>
                                  onBlur(
                                    e,
                                    "alignersStatisticsaverageDurationadults"
                                  )
                                }
                              ></Input>
                            </Form.Item>
                          </Col>
                        )}
                      {averageDurationItems.length == 1 &&
                        averageDurationItems[0].fieldName == "teens" &&
                        ToolStore.numbersToTest.w25 > 0 && (
                          <Col md={6} xl={8}>
                            <Form.Item
                              name="alignersStatisticsaverageDurationteens"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                type="number"
                                suffix={
                                  averageDurationItems[0].suffix &&
                                  averageDurationItems[0].suffix
                                }
                                prefix={
                                  averageDurationItems[0].prefix &&
                                  averageDurationItems[0].prefix
                                }
                                className={
                                  !WorkflowStore.changed
                                    .alignersStatisticsaverageDurationteens &&
                                  "roi--input-default"
                                }
                                onChange={(e) =>
                                  onChange(
                                    "alignersStatisticsaverageDurationteens",
                                    e
                                  )
                                }
                                onBlur={(e) =>
                                  onBlur(
                                    e,
                                    "alignersStatisticsaverageDurationteens"
                                  )
                                }
                              ></Input>
                            </Form.Item>
                          </Col>
                        )}
                    </Row>
                    {ToolStore.conditions.separateTeensAdults &&
                      averageDurationItems.length > 1 && (
                        <>
                          {ToolStore.numbersToTest.w24 > 0 && (
                            <Row style={{ marginTop: "1vh" }}>
                              <Col xl={2} md={2} />
                              <Col xl={14} md={12}>
                                <span className="roi--label-section roi--border-adults">
                                  <FormattedMessage id="adults" />
                                </span>
                              </Col>
                              <Col xl={8} md={6}>
                                <Form.Item
                                  name="alignersStatisticsaverageDurationadults"
                                  rules={[{ validator: dataSuperior0 }]}
                                >
                                  <Input
                                    prefix={averageDurationItems[0].prefix}
                                    suffix={averageDurationItems[0].suffix}
                                    className={
                                      !WorkflowStore.changed
                                        .alignersStatisticsaverageDurationadults &&
                                      "roi--input-default"
                                    }
                                    onBlur={(e) =>
                                      onBlur(
                                        e,
                                        "alignersStatisticsaverageDurationadults"
                                      )
                                    }
                                    onChange={(e) =>
                                      onChange(
                                        "alignersStatisticsaverageDurationadults",
                                        e
                                      )
                                    }
                                    type="number"
                                  ></Input>
                                </Form.Item>
                              </Col>
                            </Row>
                          )}
                          {ToolStore.numbersToTest.w25 > 0 && (
                            <Row style={{ marginTop: "1vh" }}>
                              <Col xl={2} md={2} />
                              <Col xl={14} md={12}>
                                <span className="roi--label-section roi--border-adults">
                                  <FormattedMessage id="teens" />
                                </span>
                              </Col>
                              <Col xl={8} md={6}>
                                <Form.Item
                                  name="alignersStatisticsaverageDurationteens"
                                  rules={[{ validator: dataSuperior0 }]}
                                >
                                  <Input
                                    prefix={averageDurationItems[1].prefix}
                                    suffix={averageDurationItems[1].suffix}
                                    className={
                                      !WorkflowStore.changed
                                        .alignersStatisticsaverageDurationteens &&
                                      "roi--input-default"
                                    }
                                    onBlur={(e) =>
                                      onBlur(
                                        e,
                                        "alignersStatisticsaverageDurationteens"
                                      )
                                    }
                                    onChange={(e) =>
                                      onChange(
                                        "alignersStatisticsaverageDurationteens",
                                        e
                                      )
                                    }
                                    type="number"
                                  ></Input>
                                </Form.Item>
                              </Col>
                            </Row>
                          )}{" "}
                        </>
                      )}
                  </Col>
                  <Col xl={2} md={0} xs={0}></Col>
                </>
              )}
              {appointmentsOverTreatmentItems.length > 0 && (
                <>
                  <Col xl={10} md={24}>
                    <Row>
                      <Col xl={2} md={2}>
                        <Tooltip
                          color="#EBEBEA"
                          fontFamily="Gotham"
                          fontSize="20px"
                          style={{ textColor: "#6a6e80" }}
                          placement="rightTop"
                          title={
                            <FormattedMessage id="appointmentsOverTreatmentTooltip" />
                          }
                        >
                          <img src="/images/icons/bull.svg" />
                        </Tooltip>
                      </Col>
                      <Col md={12} xl={14}>
                        <span
                          className="roi--label-section"
                          style={{ marginTop: "10px" }}
                        >
                          <FormattedMessage id="appointmentsOverTreatment" />
                        </span>
                      </Col>
                      {ToolStore.numbersToTest.w24 > 0 &&
                        appointmentsOverTreatmentItems[0].fieldName ==
                          "adults" &&
                        appointmentsOverTreatmentItems.length == 1 && (
                          <Col md={6} xl={8}>
                            <Form.Item
                              name="alignersStatisticsappointmentsOverTreatmentadults"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                type="number"
                                suffix={
                                  appointmentsOverTreatmentItems[0].suffix &&
                                  appointmentsOverTreatmentItems[0].suffix
                                }
                                prefix={
                                  appointmentsOverTreatmentItems[0].prefix &&
                                  appointmentsOverTreatmentItems[0].prefix
                                }
                                className={
                                  !WorkflowStore.changed
                                    .alignersStatisticsappointmentsOverTreatmentadults &&
                                  "roi--input-default"
                                }
                                onBlur={(e) =>
                                  onBlur(
                                    e,
                                    "alignersStatisticsappointmentsOverTreatmentadults"
                                  )
                                }
                                onChange={(e) =>
                                  onChange(
                                    "alignersStatisticsappointmentsOverTreatmentadults",
                                    e
                                  )
                                }
                              ></Input>
                            </Form.Item>
                          </Col>
                        )}
                      {ToolStore.numbersToTest.w25 > 0 &&
                        appointmentsOverTreatmentItems[0].fieldName ==
                          "teens" &&
                        appointmentsOverTreatmentItems.length == 1 && (
                          <Col md={6} xl={8}>
                            <Form.Item
                              name="alignersStatisticsappointmentsOverTreatmentteens"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                type="number"
                                suffix={
                                  appointmentsOverTreatmentItems[0].suffix &&
                                  appointmentsOverTreatmentItems[0].suffix
                                }
                                prefix={
                                  appointmentsOverTreatmentItems[0].prefix &&
                                  appointmentsOverTreatmentItems[0].prefix
                                }
                                className={
                                  !WorkflowStore.changed
                                    .alignersStatisticsappointmentsOverTreatmentteens &&
                                  "roi--input-default"
                                }
                                onBlur={(e) =>
                                  onBlur(
                                    e,
                                    "alignersStatisticsappointmentsOverTreatmentteens"
                                  )
                                }
                                onChange={(e) =>
                                  onChange(
                                    "alignersStatisticsappointmentsOverTreatmentteens",
                                    e
                                  )
                                }
                              ></Input>
                            </Form.Item>
                          </Col>
                        )}
                    </Row>
                    {ToolStore.conditions.separateTeensAdults &&
                      appointmentsOverTreatmentItems.length > 1 && (
                        <>
                          {ToolStore.numbersToTest.w24 > 0 && (
                            <Row style={{ marginTop: "1vh" }}>
                              <Col xl={2} md={2} />
                              <Col xl={14} md={12}>
                                <span className="roi--label-section roi--border-adults">
                                  <FormattedMessage id="adults" />
                                </span>
                              </Col>
                              <Col xl={8} md={6}>
                                <Form.Item
                                  name="alignersStatisticsappointmentsOverTreatmentadults"
                                  rules={[{ validator: dataSuperior0 }]}
                                >
                                  <Input
                                    prefix={
                                      appointmentsOverTreatmentItems[0].prefix
                                    }
                                    suffix={
                                      appointmentsOverTreatmentItems[0].suffix
                                    }
                                    className={
                                      !WorkflowStore.changed
                                        .alignersStatisticsappointmentsOverTreatmentadults &&
                                      "roi--input-default"
                                    }
                                    onBlur={(e) =>
                                      onBlur(
                                        e,
                                        "alignersStatisticsappointmentsOverTreatmentadults"
                                      )
                                    }
                                    onChange={(e) =>
                                      onChange(
                                        "alignersStatisticsappointmentsOverTreatmentadults",
                                        e
                                      )
                                    }
                                    type="number"
                                  ></Input>
                                </Form.Item>
                              </Col>
                            </Row>
                          )}
                          {ToolStore.numbersToTest.w25 > 0 && (
                            <Row style={{ marginTop: "1vh" }}>
                              <Col xl={2} md={2} />
                              <Col xl={14} md={12}>
                                <span className="roi--label-section roi--border-adults">
                                  <FormattedMessage id="teens" />
                                </span>
                              </Col>
                              <Col xl={8} md={6}>
                                <Form.Item
                                  name="alignersStatisticsappointmentsOverTreatmentteens"
                                  rules={[{ validator: dataSuperior0 }]}
                                >
                                  <Input
                                    prefix={
                                      appointmentsOverTreatmentItems[1].prefix
                                    }
                                    suffix={
                                      appointmentsOverTreatmentItems[1].suffix
                                    }
                                    className={
                                      !WorkflowStore.changed
                                        .alignersStatisticsappointmentsOverTreatmentteens &&
                                      "roi--input-default"
                                    }
                                    onBlur={(e) =>
                                      onBlur(
                                        e,
                                        "alignersStatisticsappointmentsOverTreatmentteens"
                                      )
                                    }
                                    onChange={(e) =>
                                      onChange(
                                        "alignersStatisticsappointmentsOverTreatmentteens",
                                        e
                                      )
                                    }
                                    type="number"
                                  ></Input>
                                </Form.Item>
                              </Col>
                            </Row>
                          )}
                        </>
                      )}
                  </Col>
                  <Col xl={2} md={0} xs={0}></Col>
                </>
              )}
            </Row>
            <Row>
              {appointementRefinementItems.length > 0 && (
                <>
                  <Col xl={10} md={24}>
                    <Row>
                      <Col xl={2} md={2}>
                        <Tooltip
                          color="#EBEBEA"
                          fontFamily="Gotham"
                          fontSize="20px"
                          style={{ textColor: "#6a6e80" }}
                          placement="rightTop"
                          title={
                            <FormattedMessage id="appointementRefinementTooltip" />
                          }
                        >
                          <img src="/images/icons/bull.svg" />
                        </Tooltip>
                      </Col>
                      <Col md={12} xl={14}>
                        <span
                          className="roi--label-section"
                          style={{ marginTop: "10px" }}
                        >
                          <FormattedMessage id="appointementRefinement" />
                        </span>
                      </Col>
                      {ToolStore.numbersToTest.w24 > 0 &&
                        appointementRefinementItems[0].fieldName == "adults" &&
                        appointementRefinementItems.length == 1 && (
                          <Col md={6} xl={8}>
                            <Form.Item
                              name="alignersStatisticsappointementRefinementadults"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                type="number"
                                suffix={
                                  appointementRefinementItems[0].suffix &&
                                  appointementRefinementItems[0].suffix
                                }
                                prefix={
                                  appointementRefinementItems[0].prefix &&
                                  appointementRefinementItems[0].prefix
                                }
                                className={
                                  !WorkflowStore.changed
                                    .alignersStatisticsappointementRefinementadults &&
                                  "roi--input-default"
                                }
                                onChange={(e) =>
                                  onChange(
                                    "alignersStatisticsappointementRefinementadults",
                                    e
                                  )
                                }
                                onBlur={(e) =>
                                  onBlur(
                                    e,
                                    "alignersStatisticsappointementRefinementadults"
                                  )
                                }
                              ></Input>
                            </Form.Item>
                          </Col>
                        )}
                      {ToolStore.numbersToTest.w25 > 0 &&
                        appointementRefinementItems[0].fieldName == "teens" &&
                        appointementRefinementItems.length == 1 && (
                          <Col md={6} xl={8}>
                            <Form.Item
                              name="alignersStatisticsappointementRefinementteens"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                type="number"
                                suffix={
                                  appointementRefinementItems[0].suffix &&
                                  appointementRefinementItems[0].suffix
                                }
                                prefix={
                                  appointementRefinementItems[0].prefix &&
                                  appointementRefinementItems[0].prefix
                                }
                                className={
                                  !WorkflowStore.changed
                                    .alignersStatisticsappointementRefinementteens &&
                                  "roi--input-default"
                                }
                                onChange={(e) =>
                                  onChange(
                                    "alignersStatisticsappointementRefinementteens",
                                    e
                                  )
                                }
                                onBlur={(e) =>
                                  onBlur(
                                    e,
                                    "alignersStatisticsappointementRefinementteens"
                                  )
                                }
                              ></Input>
                            </Form.Item>
                          </Col>
                        )}
                    </Row>
                    {appointementRefinementItems.length > 1 && (
                      <>
                        {ToolStore.numbersToTest.w24 > 0 && (
                          <Row style={{ marginTop: "1vh" }}>
                            <Col xl={2} md={2} />
                            <Col xl={14} md={12}>
                              <span className="roi--label-section roi--border-adults">
                                <FormattedMessage id="adults" />
                              </span>
                            </Col>
                            <Col xl={8} md={6}>
                              <Form.Item
                                name="alignersStatisticsappointementRefinementadults"
                                rules={[{ validator: dataSuperior0 }]}
                              >
                                <Input
                                  prefix={appointementRefinementItems[0].prefix}
                                  suffix={appointementRefinementItems[0].suffix}
                                  className={
                                    !WorkflowStore.changed
                                      .alignersStatisticsappointementRefinementadults &&
                                    "roi--input-default"
                                  }
                                  onBlur={(e) =>
                                    onBlur(
                                      e,
                                      "alignersStatisticsappointementRefinementadults"
                                    )
                                  }
                                  onChange={(e) =>
                                    onChange(
                                      "alignersStatisticsappointementRefinementadults",
                                      e
                                    )
                                  }
                                  type="number"
                                ></Input>
                              </Form.Item>
                            </Col>
                          </Row>
                        )}
                        {ToolStore.numbersToTest.w25 > 0 && (
                          <Row style={{ marginTop: "1vh" }}>
                            <Col xl={2} md={2} />
                            <Col xl={14} md={12}>
                              <span className="roi--label-section roi--border-adults">
                                <FormattedMessage id="teens" />
                              </span>
                            </Col>
                            <Col xl={8} md={6}>
                              <Form.Item
                                name="alignersStatisticsappointementRefinementteens"
                                rules={[{ validator: dataSuperior0 }]}
                              >
                                <Input
                                  prefix={appointementRefinementItems[1].prefix}
                                  suffix={appointementRefinementItems[1].suffix}
                                  className={
                                    !WorkflowStore.changed
                                      .alignersStatisticsappointementRefinementteens &&
                                    "roi--input-default"
                                  }
                                  onBlur={(e) =>
                                    onBlur(
                                      e,
                                      "alignersStatisticsappointementRefinementteens"
                                    )
                                  }
                                  onChange={(e) =>
                                    onChange(
                                      "alignersStatisticsappointementRefinementteens",
                                      e
                                    )
                                  }
                                  type="number"
                                ></Input>
                              </Form.Item>
                            </Col>
                          </Row>
                        )}{" "}
                      </>
                    )}
                  </Col>
                  <Col xl={2} md={0} xs={0}></Col>
                </>
              )}
              {emergencyAppointmentsItems.length > 0 && (
                <>
                  <Col xl={10} md={24}>
                    <Row>
                      <Col xl={2} md={2}>
                        <Tooltip
                          color="#EBEBEA"
                          fontFamily="Gotham"
                          fontSize="20px"
                          style={{ textColor: "#6a6e80" }}
                          placement="rightTop"
                          title={
                            <FormattedMessage id="emergencyAppointmentsTooltip" />
                          }
                        >
                          <img src="/images/icons/bull.svg" />
                        </Tooltip>
                      </Col>
                      <Col md={12} xl={14}>
                        <span
                          className="roi--label-section"
                          style={{ marginTop: "10px" }}
                        >
                          <FormattedMessage id="emergencyAppointments" />
                        </span>
                      </Col>
                      {ToolStore.numbersToTest.w24 > 0 &&
                        emergencyAppointmentsItems.length == 1 && (
                          <Col md={6} xl={8}>
                            <Form.Item
                              name="alignersStatisticsemergencyAppointmentsadults"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                type="number"
                                suffix={
                                  emergencyAppointmentsItems[0].suffix &&
                                  emergencyAppointmentsItems[0].suffix
                                }
                                prefix={
                                  emergencyAppointmentsItems[0].prefix &&
                                  emergencyAppointmentsItems[0].prefix
                                }
                                className={
                                  !WorkflowStore.changed
                                    .alignersStatisticsemergencyAppointmentsadults &&
                                  "roi--input-default"
                                }
                                onBlur={(e) =>
                                  onBlur(
                                    e,
                                    "alignersStatisticsemergencyAppointmentsadults"
                                  )
                                }
                                onChange={(e) =>
                                  onChange(
                                    "alignersStatisticsemergencyAppointmentsadults",
                                    e
                                  )
                                }
                              ></Input>
                            </Form.Item>
                          </Col>
                        )}
                      {ToolStore.conditions.separateTeensAdults &&
                        ToolStore.numbersToTest.w25 > 0 &&
                        emergencyAppointmentsItems.length == 1 && (
                          <Col md={6} xl={8}>
                            <Form.Item
                              name="alignersStatisticsemergencyAppointmentsteens"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                type="number"
                                suffix={
                                  emergencyAppointmentsItems[0].suffix &&
                                  emergencyAppointmentsItems[0].suffix
                                }
                                prefix={
                                  emergencyAppointmentsItems[0].prefix &&
                                  emergencyAppointmentsItems[0].prefix
                                }
                                className={
                                  !WorkflowStore.changed
                                    .alignersStatisticsemergencyAppointmentsteens &&
                                  "roi--input-default"
                                }
                                onBlur={(e) =>
                                  onBlur(
                                    e,
                                    "alignersStatisticsemergencyAppointmentsteens"
                                  )
                                }
                                onChange={(e) =>
                                  onChange(
                                    "alignersStatisticsemergencyAppointmentsteens",
                                    e
                                  )
                                }
                              ></Input>
                            </Form.Item>
                          </Col>
                        )}
                    </Row>
                    {emergencyAppointmentsItems.length > 1 && (
                      <>
                        {ToolStore.numbersToTest.w24 > 0 && (
                          <Row style={{ marginTop: "1vh" }}>
                            <Col xl={2} md={2} />
                            <Col xl={14} md={12}>
                              <span className="roi--label-section roi--border-adults">
                                <FormattedMessage id="adults" />
                              </span>
                            </Col>
                            <Col xl={8} md={6}>
                              <Form.Item
                                name="alignersStatisticsemergencyAppointmentsadults"
                                rules={[{ validator: dataSuperior0 }]}
                              >
                                <Input
                                  prefix={emergencyAppointmentsItems[0].prefix}
                                  suffix={emergencyAppointmentsItems[0].suffix}
                                  className={
                                    !WorkflowStore.changed
                                      .alignersStatisticsemergencyAppointmentsadults &&
                                    "roi--input-default"
                                  }
                                  onBlur={(e) =>
                                    onBlur(
                                      e,
                                      "alignersStatisticsemergencyAppointmentsadults"
                                    )
                                  }
                                  onChange={(e) =>
                                    onChange(
                                      "alignersStatisticsemergencyAppointmentsadults",
                                      e
                                    )
                                  }
                                  type="number"
                                ></Input>
                              </Form.Item>
                            </Col>
                          </Row>
                        )}
                        {ToolStore.numbersToTest.w25 > 0 && (
                          <Row style={{ marginTop: "1vh" }}>
                            <Col xl={2} md={2} />
                            <Col xl={14} md={12}>
                              <span className="roi--label-section roi--border-adults">
                                <FormattedMessage id="teens" />
                              </span>
                            </Col>
                            <Col xl={8} md={6}>
                              <Form.Item
                                name="alignersStatisticsemergencyAppointmentsteens"
                                rules={[{ validator: dataSuperior0 }]}
                              >
                                <Input
                                  prefix={emergencyAppointmentsItems[1].prefix}
                                  suffix={emergencyAppointmentsItems[1].suffix}
                                  className={
                                    !WorkflowStore.changed
                                      .alignersStatisticsemergencyAppointmentsteens &&
                                    "roi--input-default"
                                  }
                                  onBlur={(e) =>
                                    onBlur(
                                      e,
                                      "alignersStatisticsemergencyAppointmentsteens"
                                    )
                                  }
                                  onChange={(e) =>
                                    onChange(
                                      "alignersStatisticsemergencyAppointmentsteens",
                                      e
                                    )
                                  }
                                  type="number"
                                ></Input>
                              </Form.Item>
                            </Col>
                          </Row>
                        )}
                      </>
                    )}
                  </Col>
                  <Col xl={2} md={0} xs={0}></Col>
                </>
              )}
            </Row>{" "}
          </Panel>
        </Collapse>
      );
    } else {
      return "";
    }
  };

  const alignersCost = () => {
    const costAlignersData = toGetElement("alignersCost", "costAlignersData");
    const consumables = toGetElement("alignersCost", "consumables");

    if (displayAll) {
      return (
        <Collapse defaultActiveKey={["1"]}>
          <Panel
            header={
              <Row className="dashed" style={{ marginTop: "2vh" }}>
                <span className=" roi--second-collapse-title">
                  <FormattedMessage id="alignersCost" />
                </span>
              </Row>
            }
            key="1"
          >
            <Row>
              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={<FormattedMessage id="costAlignersDataTooltip" />}
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="costAlignersData" />
                    </span>
                  </Col>
                  <Col md={6} xl={8}>
                    <Form.Item
                      name="alignersCostcostAlignersData"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        type="number"
                        suffix={
                          costAlignersData.suffix && costAlignersData.suffix
                        }
                        prefix={ToolStore.symbol}
                        className={
                          !WorkflowStore.changed.alignersCostcostAlignersData &&
                          "roi--input-default"
                        }
                        onChange={(e) =>
                          onChange("alignersCostcostAlignersData", e)
                        }
                        onBlur={(e) =>
                          onBlur(e, "alignersCostcostAlignersData")
                        }
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>

              <Col xl={2} md={0} xs={0}></Col>

              <Col xl={10} md={24} xs={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={<FormattedMessage id="consumablesTooltip" />}
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="consumables" />
                    </span>
                  </Col>
                  <Col md={6} xl={8}>
                    <Form.Item
                      name="alignersCostconsumables"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        type="number"
                        suffix={consumables.suffix && consumables.suffix}
                        prefix={ToolStore.symbol}
                        onChange={(e) => onChange("alignersCostconsumables", e)}
                        onBlur={(e) => onBlur(e, "alignersCostconsumables")}
                        className={
                          !WorkflowStore.changed.alignersCostconsumables &&
                          "roi--input-default"
                        }
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Panel>
        </Collapse>
      );
    }
    if (
      (costAlignersData.display && costAlignersData.display != -1) ||
      (consumables.display && consumables.display != -1)
    ) {
      return (
        <Collapse defaultActiveKey={["1"]}>
          <Panel
            header={
              <Row className="dashed" style={{ marginTop: "2vh" }}>
                <span className=" roi--second-collapse-title">
                  <FormattedMessage id="alignersCost" />
                </span>
              </Row>
            }
            key="1"
          >
            <Row>
              {costAlignersData.display && costAlignersData.display != -1 && (
                <>
                  <Col xl={10} md={24}>
                    <Row>
                      <Col xl={2} md={2}>
                        <Tooltip
                          color="#EBEBEA"
                          fontFamily="Gotham"
                          fontSize="20px"
                          style={{ textColor: "#6a6e80" }}
                          placement="rightTop"
                          title={
                            <FormattedMessage id="costAlignersDataTooltip" />
                          }
                        >
                          <img src="/images/icons/bull.svg" />
                        </Tooltip>
                      </Col>
                      <Col md={12} xl={14}>
                        <span
                          className="roi--label-section"
                          style={{ marginTop: "10px" }}
                        >
                          <FormattedMessage id="costAlignersData" />
                        </span>
                      </Col>
                      <Col md={6} xl={8}>
                        <Form.Item
                          name="alignersCostcostAlignersData"
                          rules={[{ validator: dataSuperior0 }]}
                        >
                          <Input
                            type="number"
                            suffix={
                              costAlignersData.suffix && costAlignersData.suffix
                            }
                            prefix={ToolStore.symbol}
                            className={
                              !WorkflowStore.changed
                                .alignersCostcostAlignersData &&
                              "roi--input-default"
                            }
                            onChange={(e) =>
                              onChange("alignersCostcostAlignersData", e)
                            }
                            onBlur={(e) =>
                              onBlur(e, "alignersCostcostAlignersData")
                            }
                          ></Input>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>

                  <Col xl={2} md={0} xs={0}></Col>
                </>
              )}
              {consumables.display && consumables.display != -1 && (
                <Col xl={10} md={24} xs={24}>
                  <Row>
                    <Col xl={2} md={2}>
                      <Tooltip
                        color="#EBEBEA"
                        fontFamily="Gotham"
                        fontSize="20px"
                        style={{ textColor: "#6a6e80" }}
                        placement="rightTop"
                        title={<FormattedMessage id="consumablesTooltip" />}
                      >
                        <img src="/images/icons/bull.svg" />
                      </Tooltip>
                    </Col>
                    <Col md={12} xl={14}>
                      <span
                        className="roi--label-section"
                        style={{ marginTop: "10px" }}
                      >
                        <FormattedMessage id="consumables" />
                      </span>
                    </Col>
                    <Col md={6} xl={8}>
                      <Form.Item
                        name="alignersCostconsumables"
                        rules={[{ validator: dataSuperior0 }]}
                      >
                        <Input
                          type="number"
                          suffix={consumables.suffix && consumables.suffix}
                          prefix={ToolStore.symbol}
                          onChange={(e) =>
                            onChange("alignersCostconsumables", e)
                          }
                          onBlur={(e) => onBlur(e, "alignersCostconsumables")}
                          className={
                            !WorkflowStore.changed.alignersCostconsumables &&
                            "roi--input-default"
                          }
                        ></Input>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              )}
            </Row>
          </Panel>
        </Collapse>
      );
    } else {
      return "";
    }
  };

  const alignersTimeSpent = () => {
    const timeSpentCheckupAppointement = toGetElement(
      "alignersTimeSpent",
      "timeSpentCheckupAppointement"
    );

    const dentalAssistant = toGetElement(
      "alignersTimeSpent",
      "dentalAssistant"
    );
    const treatmentCoordinator = toGetElement(
      "alignersTimeSpent",
      "treatmentCoordinator"
    );
    const frontDesk = toGetElement("alignersTimeSpent", "frontDesk");
    const dentalAssistantItems = toGetSubElements(dentalAssistant);
    const treatmentCoordinatorItems = toGetSubElements(treatmentCoordinator);
    const frontDeskItems = toGetSubElements(frontDesk);
    if (displayAll) {
      return (
        <Collapse defaultActiveKey={["1"]}>
          <Panel
            header={
              <Row className="dashed" style={{ marginTop: "2vh" }}>
                <span className=" roi--second-collapse-title">
                  <FormattedMessage id="alignersTimeSpent" />
                </span>
              </Row>
            }
            key="1"
          >
            <Row>
              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={
                        <FormattedMessage id="timeSpentCheckupAppointementTooltip" />
                      }
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="timeSpentCheckupAppointement" />
                    </span>
                  </Col>
                  <Col md={6} xl={8}>
                    <Form.Item
                      name="alignersTimeSpenttimeSpentCheckupAppointement"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        type="number"
                        suffix={
                          timeSpentCheckupAppointement.suffix &&
                          timeSpentCheckupAppointement.suffix
                        }
                        prefix={
                          timeSpentCheckupAppointement.prefix &&
                          timeSpentCheckupAppointement.prefix
                        }
                        className={
                          !WorkflowStore.changed
                            .alignersTimeSpenttimeSpentCheckupAppointement &&
                          "roi--input-default"
                        }
                        onChange={(e) =>
                          onChange(
                            "alignersTimeSpenttimeSpentCheckupAppointement",
                            e
                          )
                        }
                        onBlur={(e) =>
                          onBlur(
                            e,
                            "alignersTimeSpenttimeSpentCheckupAppointement"
                          )
                        }
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xl={2} md={0} xs={0}></Col>

              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={<FormattedMessage id="dentalAssistantTooltip" />}
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage
                        id={
                          ToolStore.conditions.separateStaffRole
                            ? "dentalAssistant"
                            : "staffTimeSpents"
                        }
                      />
                    </span>
                  </Col>
                </Row>

                <Row style={{ marginTop: "1vh" }}>
                  <Col xl={2} md={2} />
                  <Col xl={14} md={12}>
                    <span className="roi--label-section roi--border-adults">
                      <FormattedMessage id="checkupAppointement" />
                    </span>
                  </Col>
                  <Col xl={8} md={6}>
                    <Form.Item
                      name="alignersTimeSpentdentalAssistantcheckupAppointement"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        prefix={dentalAssistantItems[0].prefix}
                        suffix={dentalAssistantItems[0].suffix}
                        className={
                          !WorkflowStore.changed
                            .alignersTimeSpentdentalAssistantcheckupAppointement &&
                          "roi--input-default"
                        }
                        onBlur={(e) =>
                          onBlur(
                            e,
                            "alignersTimeSpentdentalAssistantcheckupAppointement"
                          )
                        }
                        onChange={(e) =>
                          onChange(
                            "alignersTimeSpentdentalAssistantcheckupAppointement",
                            e
                          )
                        }
                        type="number"
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>

                <Row style={{ marginTop: "1vh" }}>
                  <Col xl={2} md={2} />
                  <Col xl={14} md={12}>
                    <span className="roi--label-section roi--border-adults">
                      <FormattedMessage id="prepareAppointment" />
                    </span>
                  </Col>
                  <Col xl={8} md={6}>
                    <Form.Item
                      name="alignersTimeSpentdentalAssistantprepareAppointment"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        prefix={dentalAssistantItems[1].prefix}
                        suffix={dentalAssistantItems[1].suffix}
                        className={
                          !WorkflowStore.changed
                            .alignersTimeSpentdentalAssistantprepareAppointment &&
                          "roi--input-default"
                        }
                        onBlur={(e) =>
                          onBlur(
                            e,
                            "alignersTimeSpentdentalAssistantprepareAppointment"
                          )
                        }
                        onChange={(e) =>
                          onChange(
                            "alignersTimeSpentdentalAssistantprepareAppointment",
                            e
                          )
                        }
                        type="number"
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xl={2} md={0} xs={0}></Col>
            </Row>
            <Row>
              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={
                        <FormattedMessage id="treatmentCoordinatorTooltip" />
                      }
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="treatmentCoordinator" />
                    </span>
                  </Col>
                </Row>

                <>
                  <Row style={{ marginTop: "1vh" }}>
                    <Col xl={2} md={2} />
                    <Col xl={14} md={12}>
                      <span className="roi--label-section roi--border-adults">
                        <FormattedMessage id="checkupAppointement" />
                      </span>
                    </Col>
                    <Col xl={8} md={6}>
                      <Form.Item
                        name="alignersTimeSpenttreatmentCoordinatorcheckupAppointement"
                        rules={[{ validator: dataSuperior0 }]}
                      >
                        <Input
                          prefix={treatmentCoordinatorItems[0].prefix}
                          suffix={treatmentCoordinatorItems[0].suffix}
                          className={
                            !WorkflowStore.changed
                              .alignersTimeSpenttreatmentCoordinatorcheckupAppointement &&
                            "roi--input-default"
                          }
                          onBlur={(e) =>
                            onBlur(
                              e,
                              "alignersTimeSpenttreatmentCoordinatorcheckupAppointement"
                            )
                          }
                          onChange={(e) =>
                            onChange(
                              "alignersTimeSpenttreatmentCoordinatorcheckupAppointement",
                              e
                            )
                          }
                          type="number"
                        ></Input>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row style={{ marginTop: "1vh" }}>
                    <Col xl={2} md={2} />
                    <Col xl={14} md={12}>
                      <span className="roi--label-section roi--border-adults">
                        <FormattedMessage id="prepareAppointment" />
                      </span>
                    </Col>
                    <Col xl={8} md={6}>
                      <Form.Item
                        name="alignersTimeSpenttreatmentCoordinatorprepareAppointment"
                        rules={[{ validator: dataSuperior0 }]}
                      >
                        <Input
                          prefix={treatmentCoordinatorItems[1].prefix}
                          suffix={treatmentCoordinatorItems[1].suffix}
                          className={
                            !WorkflowStore.changed
                              .alignersTimeSpenttreatmentCoordinatorprepareAppointment &&
                            "roi--input-default"
                          }
                          onBlur={(e) =>
                            onBlur(
                              e,
                              "alignersTimeSpenttreatmentCoordinatorprepareAppointment"
                            )
                          }
                          onChange={(e) =>
                            onChange(
                              "alignersTimeSpenttreatmentCoordinatorprepareAppointment",
                              e
                            )
                          }
                          type="number"
                        ></Input>
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              </Col>
              <Col xl={2} md={0} xs={0}></Col>

              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={<FormattedMessage id="frontDeskTooltip" />}
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="frontDesk" />
                    </span>
                  </Col>
                </Row>

                <Row style={{ marginTop: "1vh" }}>
                  <Col xl={2} md={2} />
                  <Col xl={14} md={12}>
                    <span className="roi--label-section roi--border-adults">
                      <FormattedMessage id="checkupAppointement" />
                    </span>
                  </Col>
                  <Col xl={8} md={6}>
                    <Form.Item
                      name="alignersTimeSpentfrontDeskcheckupAppointement"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        prefix={frontDeskItems[0].prefix}
                        suffix={frontDeskItems[0].suffix}
                        className={
                          !WorkflowStore.changed
                            .alignersTimeSpentfrontDeskcheckupAppointement &&
                          "roi--input-default"
                        }
                        onBlur={(e) =>
                          onBlur(
                            e,
                            "alignersTimeSpentfrontDeskcheckupAppointement"
                          )
                        }
                        onChange={(e) =>
                          onChange(
                            "alignersTimeSpentfrontDeskcheckupAppointement",
                            e
                          )
                        }
                        type="number"
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>

                <Row style={{ marginTop: "1vh" }}>
                  <Col xl={2} md={2} />
                  <Col xl={14} md={12}>
                    <span className="roi--label-section roi--border-adults">
                      <FormattedMessage id="takeAppointment" />
                    </span>
                  </Col>
                  <Col xl={8} md={6}>
                    <Form.Item
                      name="alignersTimeSpentfrontDesktakeAppointment"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        prefix={frontDeskItems[1].prefix}
                        suffix={frontDeskItems[1].suffix}
                        className={
                          !WorkflowStore.changed
                            .alignersTimeSpentfrontDesktakeAppointment &&
                          "roi--input-default"
                        }
                        onBlur={(e) =>
                          onBlur(e, "alignersTimeSpentfrontDesktakeAppointment")
                        }
                        onChange={(e) =>
                          onChange(
                            "alignersTimeSpentfrontDesktakeAppointment",
                            e
                          )
                        }
                        type="number"
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xl={2} md={0} xs={0}></Col>
            </Row>{" "}
          </Panel>
        </Collapse>
      );
    }
    if (
      (ToolStore.conditions.showHourly &&
        timeSpentCheckupAppointement.display &&
        timeSpentCheckupAppointement.display != -1) ||
      dentalAssistantItems.length > 0 ||
      (ToolStore.conditions.separateStaffRole &&
        treatmentCoordinatorItems.length > 0) ||
      (ToolStore.conditions.separateStaffRole && frontDeskItems.length > 0)
    ) {
      return (
        <Collapse defaultActiveKey={["1"]}>
          <Panel
            header={
              <Row className="dashed" style={{ marginTop: "2vh" }}>
                <span className=" roi--second-collapse-title">
                  <FormattedMessage id="alignersTimeSpent" />
                </span>
              </Row>
            }
            key="1"
          >
            <Row>
              {ToolStore.conditions.showHourly &&
                timeSpentCheckupAppointement.display &&
                timeSpentCheckupAppointement.display != -1 && (
                  <>
                    <Col xl={10} md={24}>
                      <Row>
                        <Col xl={2} md={2}>
                          <Tooltip
                            color="#EBEBEA"
                            fontFamily="Gotham"
                            fontSize="20px"
                            style={{ textColor: "#6a6e80" }}
                            placement="rightTop"
                            title={
                              <FormattedMessage id="timeSpentCheckupAppointementTooltip" />
                            }
                          >
                            <img src="/images/icons/bull.svg" />
                          </Tooltip>
                        </Col>
                        <Col md={12} xl={14}>
                          <span
                            className="roi--label-section"
                            style={{ marginTop: "10px" }}
                          >
                            <FormattedMessage id="timeSpentCheckupAppointement" />
                          </span>
                        </Col>
                        <Col md={6} xl={8}>
                          <Form.Item
                            name="alignersTimeSpenttimeSpentCheckupAppointement"
                            rules={[{ validator: dataSuperior0 }]}
                          >
                            <Input
                              type="number"
                              suffix={
                                timeSpentCheckupAppointement.suffix &&
                                timeSpentCheckupAppointement.suffix
                              }
                              prefix={
                                timeSpentCheckupAppointement.prefix &&
                                timeSpentCheckupAppointement.prefix
                              }
                              className={
                                !WorkflowStore.changed
                                  .alignersTimeSpenttimeSpentCheckupAppointement &&
                                "roi--input-default"
                              }
                              onChange={(e) =>
                                onChange(
                                  "alignersTimeSpenttimeSpentCheckupAppointement",
                                  e
                                )
                              }
                              onBlur={(e) =>
                                onBlur(
                                  e,
                                  "alignersTimeSpenttimeSpentCheckupAppointement"
                                )
                              }
                            ></Input>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                    <Col xl={2} md={0} xs={0}></Col>
                  </>
                )}
              {dentalAssistantItems.length > 0 && (
                <>
                  <Col xl={10} md={24}>
                    <Row>
                      <Col xl={2} md={2}>
                        <Tooltip
                          color="#EBEBEA"
                          fontFamily="Gotham"
                          fontSize="20px"
                          style={{ textColor: "#6a6e80" }}
                          placement="rightTop"
                          title={
                            <FormattedMessage id="dentalAssistantTooltip" />
                          }
                        >
                          <img src="/images/icons/bull.svg" />
                        </Tooltip>
                      </Col>
                      <Col md={12} xl={14}>
                        <span
                          className="roi--label-section"
                          style={{ marginTop: "10px" }}
                        >
                          <FormattedMessage
                            id={
                              ToolStore.conditions.separateStaffRole
                                ? "dentalAssistant"
                                : "staffTimeSpents"
                            }
                          />
                        </span>
                      </Col>
                      {!ToolStore.conditions.separateStaffRole && (
                        <Col md={6} xl={8}>
                          <Form.Item
                            name="alignersTimeSpentdentalAssistantcheckupAppointement"
                            rules={[{ validator: dataSuperior0 }]}
                          >
                            <Input
                              type="number"
                              suffix={
                                dentalAssistantItems[0].suffix &&
                                dentalAssistantItems[0].suffix
                              }
                              prefix={
                                dentalAssistantItems[0].prefix &&
                                dentalAssistantItems[0].prefix
                              }
                              className={
                                !WorkflowStore.changed
                                  .alignersTimeSpentdentalAssistantcheckupAppointement &&
                                "roi--input-default"
                              }
                              onChange={(e) =>
                                onChange(
                                  "alignersTimeSpentdentalAssistantcheckupAppointement",
                                  e
                                )
                              }
                              onBlur={(e) =>
                                onBlur(
                                  e,
                                  "alignersTimeSpentdentalAssistantcheckupAppointement"
                                )
                              }
                            ></Input>
                          </Form.Item>
                        </Col>
                      )}
                    </Row>
                    {ToolStore.conditions.separateStaffRole && (
                      <>
                        <Row style={{ marginTop: "1vh" }}>
                          <Col xl={2} md={2} />
                          <Col xl={14} md={12}>
                            <span className="roi--label-section roi--border-adults">
                              <FormattedMessage id="checkupAppointement" />
                            </span>
                          </Col>
                          <Col xl={8} md={6}>
                            <Form.Item
                              name="alignersTimeSpentdentalAssistantcheckupAppointement"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                prefix={dentalAssistantItems[0].prefix}
                                suffix={dentalAssistantItems[0].suffix}
                                className={
                                  !WorkflowStore.changed
                                    .alignersTimeSpentdentalAssistantcheckupAppointement &&
                                  "roi--input-default"
                                }
                                onBlur={(e) =>
                                  onBlur(
                                    e,
                                    "alignersTimeSpentdentalAssistantcheckupAppointement"
                                  )
                                }
                                onChange={(e) =>
                                  onChange(
                                    "alignersTimeSpentdentalAssistantcheckupAppointement",
                                    e
                                  )
                                }
                                type="number"
                              ></Input>
                            </Form.Item>
                          </Col>
                        </Row>

                        <Row style={{ marginTop: "1vh" }}>
                          <Col xl={2} md={2} />
                          <Col xl={14} md={12}>
                            <span className="roi--label-section roi--border-adults">
                              <FormattedMessage id="prepareAppointment" />
                            </span>
                          </Col>
                          <Col xl={8} md={6}>
                            <Form.Item
                              name="alignersTimeSpentdentalAssistantprepareAppointment"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                prefix={dentalAssistantItems[1].prefix}
                                suffix={dentalAssistantItems[1].suffix}
                                className={
                                  !WorkflowStore.changed
                                    .alignersTimeSpentdentalAssistantprepareAppointment &&
                                  "roi--input-default"
                                }
                                onBlur={(e) =>
                                  onBlur(
                                    e,
                                    "alignersTimeSpentdentalAssistantprepareAppointment"
                                  )
                                }
                                onChange={(e) =>
                                  onChange(
                                    "alignersTimeSpentdentalAssistantprepareAppointment",
                                    e
                                  )
                                }
                                type="number"
                              ></Input>
                            </Form.Item>
                          </Col>
                        </Row>
                      </>
                    )}
                  </Col>
                  <Col xl={2} md={0} xs={0}></Col>
                </>
              )}
            </Row>
            <Row>
              {ToolStore.conditions.separateStaffRole &&
                treatmentCoordinatorItems.length > 0 && (
                  <>
                    <Col xl={10} md={24}>
                      <Row>
                        <Col xl={2} md={2}>
                          <Tooltip
                            color="#EBEBEA"
                            fontFamily="Gotham"
                            fontSize="20px"
                            style={{ textColor: "#6a6e80" }}
                            placement="rightTop"
                            title={
                              <FormattedMessage id="treatmentCoordinatorTooltip" />
                            }
                          >
                            <img src="/images/icons/bull.svg" />
                          </Tooltip>
                        </Col>
                        <Col md={12} xl={14}>
                          <span
                            className="roi--label-section"
                            style={{ marginTop: "10px" }}
                          >
                            <FormattedMessage id="treatmentCoordinator" />
                          </span>
                        </Col>
                      </Row>

                      <>
                        <Row style={{ marginTop: "1vh" }}>
                          <Col xl={2} md={2} />
                          <Col xl={14} md={12}>
                            <span className="roi--label-section roi--border-adults">
                              <FormattedMessage id="checkupAppointement" />
                            </span>
                          </Col>
                          <Col xl={8} md={6}>
                            <Form.Item
                              name="alignersTimeSpenttreatmentCoordinatorcheckupAppointement"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                prefix={treatmentCoordinatorItems[0].prefix}
                                suffix={treatmentCoordinatorItems[0].suffix}
                                className={
                                  !WorkflowStore.changed
                                    .alignersTimeSpenttreatmentCoordinatorcheckupAppointement &&
                                  "roi--input-default"
                                }
                                onBlur={(e) =>
                                  onBlur(
                                    e,
                                    "alignersTimeSpenttreatmentCoordinatorcheckupAppointement"
                                  )
                                }
                                onChange={(e) =>
                                  onChange(
                                    "alignersTimeSpenttreatmentCoordinatorcheckupAppointement",
                                    e
                                  )
                                }
                                type="number"
                              ></Input>
                            </Form.Item>
                          </Col>
                        </Row>

                        <Row style={{ marginTop: "1vh" }}>
                          <Col xl={2} md={2} />
                          <Col xl={14} md={12}>
                            <span className="roi--label-section roi--border-adults">
                              <FormattedMessage id="prepareAppointment" />
                            </span>
                          </Col>
                          <Col xl={8} md={6}>
                            <Form.Item
                              name="alignersTimeSpenttreatmentCoordinatorprepareAppointment"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                prefix={treatmentCoordinatorItems[1].prefix}
                                suffix={treatmentCoordinatorItems[1].suffix}
                                className={
                                  !WorkflowStore.changed
                                    .alignersTimeSpenttreatmentCoordinatorprepareAppointment &&
                                  "roi--input-default"
                                }
                                onBlur={(e) =>
                                  onBlur(
                                    e,
                                    "alignersTimeSpenttreatmentCoordinatorprepareAppointment"
                                  )
                                }
                                onChange={(e) =>
                                  onChange(
                                    "alignersTimeSpenttreatmentCoordinatorprepareAppointment",
                                    e
                                  )
                                }
                                type="number"
                              ></Input>
                            </Form.Item>
                          </Col>
                        </Row>
                      </>
                    </Col>
                    <Col xl={2} md={0} xs={0}></Col>
                  </>
                )}
              {ToolStore.conditions.separateStaffRole &&
                frontDeskItems.length > 0 && (
                  <>
                    <Col xl={10} md={24}>
                      <Row>
                        <Col xl={2} md={2}>
                          <Tooltip
                            color="#EBEBEA"
                            fontFamily="Gotham"
                            fontSize="20px"
                            style={{ textColor: "#6a6e80" }}
                            placement="rightTop"
                            title={<FormattedMessage id="frontDeskTooltip" />}
                          >
                            <img src="/images/icons/bull.svg" />
                          </Tooltip>
                        </Col>
                        <Col md={12} xl={14}>
                          <span
                            className="roi--label-section"
                            style={{ marginTop: "10px" }}
                          >
                            <FormattedMessage id="frontDesk" />
                          </span>
                        </Col>
                      </Row>

                      <>
                        <Row style={{ marginTop: "1vh" }}>
                          <Col xl={2} md={2} />
                          <Col xl={14} md={12}>
                            <span className="roi--label-section roi--border-adults">
                              <FormattedMessage id="checkupAppointement" />
                            </span>
                          </Col>
                          <Col xl={8} md={6}>
                            <Form.Item
                              name="alignersTimeSpentfrontDeskcheckupAppointement"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                prefix={frontDeskItems[0].prefix}
                                suffix={frontDeskItems[0].suffix}
                                className={
                                  !WorkflowStore.changed
                                    .alignersTimeSpentfrontDeskcheckupAppointement &&
                                  "roi--input-default"
                                }
                                onBlur={(e) =>
                                  onBlur(
                                    e,
                                    "alignersTimeSpentfrontDeskcheckupAppointement"
                                  )
                                }
                                onChange={(e) =>
                                  onChange(
                                    "alignersTimeSpentfrontDeskcheckupAppointement",
                                    e
                                  )
                                }
                                type="number"
                              ></Input>
                            </Form.Item>
                          </Col>
                        </Row>

                        <Row style={{ marginTop: "1vh" }}>
                          <Col xl={2} md={2} />
                          <Col xl={14} md={12}>
                            <span className="roi--label-section roi--border-adults">
                              <FormattedMessage id="takeAppointment" />
                            </span>
                          </Col>
                          <Col xl={8} md={6}>
                            <Form.Item
                              name="alignersTimeSpentfrontDesktakeAppointment"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                prefix={frontDeskItems[1].prefix}
                                suffix={frontDeskItems[1].suffix}
                                className={
                                  !WorkflowStore.changed
                                    .alignersTimeSpentfrontDesktakeAppointment &&
                                  "roi--input-default"
                                }
                                onBlur={(e) =>
                                  onBlur(
                                    e,
                                    "alignersTimeSpentfrontDesktakeAppointment"
                                  )
                                }
                                onChange={(e) =>
                                  onChange(
                                    "alignersTimeSpentfrontDesktakeAppointment",
                                    e
                                  )
                                }
                                type="number"
                              ></Input>
                            </Form.Item>
                          </Col>
                        </Row>
                      </>
                    </Col>
                    <Col xl={2} md={0} xs={0}></Col>
                  </>
                )}
            </Row>
          </Panel>
        </Collapse>
      );
    } else {
      return "";
    }
  };
  const bracesStatisticsElements = () => {
    const bracesAverageDuration = toGetElement(
      "bracesStatistics",
      "bracesAverageDuration"
    );
    const bracesAppointmentsOverTreatment = toGetElement(
      "bracesStatistics",
      "bracesAppointmentsOverTreatment"
    );

    const bracesInaddition = toGetElement(
      "bracesStatistics",
      "bracesInaddition"
    );
    const bracesAverageDurationItems = toGetSubElements(bracesAverageDuration);
    const bracesAppointmentsOverTreatmentItems = toGetSubElements(
      bracesAppointmentsOverTreatment
    );

    const bracesInadditionItems = toGetSubElements(bracesInaddition);

    if (displayAll) {
      return (
        <Collapse defaultActiveKey={["1"]}>
          <Panel
            header={
              <Row className="dashed" style={{ marginTop: "2vh" }}>
                <span className="roi--second-collapse-title">
                  <FormattedMessage id="bracesStatistics" />
                </span>
              </Row>
            }
            key="1"
          >
            <Row>
              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={
                        <FormattedMessage id="bracesAverageDurationTooltip" />
                      }
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="bracesAverageDuration" />
                    </span>
                  </Col>
                </Row>

                <Row style={{ marginTop: "1vh" }}>
                  <Col xl={2} md={2} />
                  <Col xl={14} md={12}>
                    <span className="roi--label-section roi--border-adults">
                      <FormattedMessage id="adults" />
                    </span>
                  </Col>
                  <Col xl={8} md={6}>
                    <Form.Item
                      name="bracesStatisticsbracesAverageDurationadults"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        prefix={bracesAverageDurationItems[0].prefix}
                        suffix={bracesAverageDurationItems[0].suffix}
                        className={
                          !WorkflowStore.changed
                            .bracesStatisticsbracesAverageDurationadults &&
                          "roi--input-default"
                        }
                        onBlur={(e) =>
                          onBlur(
                            e,
                            "bracesStatisticsbracesAverageDurationadults"
                          )
                        }
                        onChange={(e) =>
                          onChange(
                            "bracesStatisticsbracesAverageDurationadults",
                            e
                          )
                        }
                        type="number"
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>

                <Row style={{ marginTop: "1vh" }}>
                  <Col xl={2} md={2} />
                  <Col xl={14} md={12}>
                    <span className="roi--label-section roi--border-adults">
                      <FormattedMessage id="teens" />
                    </span>
                  </Col>
                  <Col xl={8} md={6}>
                    <Form.Item
                      name="bracesStatisticsbracesAverageDurationteens"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        prefix={bracesAverageDurationItems[1].prefix}
                        suffix={bracesAverageDurationItems[1].suffix}
                        className={
                          !WorkflowStore.changed
                            .bracesStatisticsbracesAverageDurationteens &&
                          "roi--input-default"
                        }
                        onBlur={(e) =>
                          onBlur(
                            e,
                            "bracesStatisticsbracesAverageDurationteens"
                          )
                        }
                        onChange={(e) =>
                          onChange(
                            "bracesStatisticsbracesAverageDurationteens",
                            e
                          )
                        }
                        type="number"
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xl={2} md={0} xs={0}></Col>

              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={
                        <FormattedMessage id="bracesAppointmentsOverTreatmentTooltip" />
                      }
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="overTreatment" />
                    </span>
                  </Col>
                </Row>

                <Row style={{ marginTop: "1vh" }}>
                  <Col xl={2} md={2} />
                  <Col xl={14} md={12}>
                    <span className="roi--label-section roi--border-adults">
                      <FormattedMessage id="adults" />
                    </span>
                  </Col>
                  <Col xl={8} md={6}>
                    <Form.Item
                      name="bracesStatisticsbracesAppointmentsOverTreatmentadults"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        prefix={bracesAppointmentsOverTreatmentItems[0].prefix}
                        suffix={bracesAppointmentsOverTreatmentItems[0].suffix}
                        className={
                          !WorkflowStore.changed
                            .bracesStatisticsbracesAppointmentsOverTreatmentadults &&
                          "roi--input-default"
                        }
                        onBlur={(e) =>
                          onBlur(
                            e,
                            "bracesStatisticsbracesAppointmentsOverTreatmentadults"
                          )
                        }
                        onChange={(e) =>
                          onChange(
                            "bracesStatisticsbracesAppointmentsOverTreatmentadults",
                            e
                          )
                        }
                        type="number"
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>

                <Row style={{ marginTop: "1vh" }}>
                  <Col xl={2} md={2} />
                  <Col xl={14} md={12}>
                    <span className="roi--label-section roi--border-adults">
                      <FormattedMessage id="teens" />
                    </span>
                  </Col>
                  <Col xl={8} md={6}>
                    <Form.Item
                      name="bracesStatisticsbracesAppointmentsOverTreatmentteens"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        prefix={bracesAppointmentsOverTreatmentItems[1].prefix}
                        suffix={bracesAppointmentsOverTreatmentItems[1].suffix}
                        className={
                          !WorkflowStore.changed
                            .bracesStatisticsbracesAppointmentsOverTreatmentteens &&
                          "roi--input-default"
                        }
                        onBlur={(e) =>
                          onBlur(
                            e,
                            "bracesStatisticsbracesAppointmentsOverTreatmentteens"
                          )
                        }
                        onChange={(e) =>
                          onChange(
                            "bracesStatisticsbracesAppointmentsOverTreatmentteens",
                            e
                          )
                        }
                        type="number"
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xl={2} md={0} xs={0}></Col>
            </Row>{" "}
            <Row>
              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={<FormattedMessage id="bracesInadditionTooltip" />}
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="bracesInaddition" />
                    </span>
                  </Col>
                </Row>

                <Row style={{ marginTop: "1vh" }}>
                  <Col xl={2} md={2} />
                  <Col xl={14} md={12}>
                    <span className="roi--label-section roi--border-adults">
                      <FormattedMessage id="adults" />
                    </span>
                  </Col>
                  <Col xl={8} md={6}>
                    <Form.Item
                      name="bracesStatisticsbracesInadditionadults"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        prefix={bracesInadditionItems[0].prefix}
                        suffix={bracesInadditionItems[0].suffix}
                        className={
                          !WorkflowStore.changed
                            .bracesStatisticsbracesInadditionadults &&
                          "roi--input-default"
                        }
                        onBlur={(e) =>
                          onBlur(e, "bracesStatisticsbracesInadditionadults")
                        }
                        onChange={(e) =>
                          onChange("bracesStatisticsbracesInadditionadults", e)
                        }
                        type="number"
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>

                <Row style={{ marginTop: "1vh" }}>
                  <Col xl={2} md={2} />
                  <Col xl={14} md={12}>
                    <span className="roi--label-section roi--border-adults">
                      <FormattedMessage id="teens" />
                    </span>
                  </Col>
                  <Col xl={8} md={6}>
                    <Form.Item
                      name="bracesStatisticsbracesInadditionteens"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        prefix={bracesInadditionItems[1].prefix}
                        suffix={bracesInadditionItems[1].suffix}
                        className={
                          !WorkflowStore.changed
                            .bracesStatisticsbracesInadditionteens &&
                          "roi--input-default"
                        }
                        onBlur={(e) =>
                          onBlur(e, "bracesStatisticsbracesInadditionteens")
                        }
                        onChange={(e) =>
                          onChange("bracesStatisticsbracesInadditionteens", e)
                        }
                        type="number"
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xl={2} md={0} xs={0}></Col>
            </Row>{" "}
          </Panel>
        </Collapse>
      );
    }

    if (
      bracesAverageDurationItems.length > 0 ||
      bracesAppointmentsOverTreatmentItems.length > 0 ||
      bracesInadditionItems.length > 0
    ) {
      return (
        <Collapse defaultActiveKey={["1"]}>
          <Panel
            header={
              <Row className="dashed" style={{ marginTop: "2vh" }}>
                <span className="roi--second-collapse-title">
                  <FormattedMessage id="bracesStatistics" />
                </span>
              </Row>
            }
            key="1"
          >
            <Row>
              {bracesAverageDurationItems.length > 0 && (
                <>
                  <Col xl={10} md={24}>
                    <Row>
                      <Col xl={2} md={2}>
                        <Tooltip
                          color="#EBEBEA"
                          fontFamily="Gotham"
                          fontSize="20px"
                          style={{ textColor: "#6a6e80" }}
                          placement="rightTop"
                          title={
                            <FormattedMessage id="bracesAverageDurationTooltip" />
                          }
                        >
                          <img src="/images/icons/bull.svg" />
                        </Tooltip>
                      </Col>
                      <Col md={12} xl={14}>
                        <span
                          className="roi--label-section"
                          style={{ marginTop: "10px" }}
                        >
                          <FormattedMessage id="bracesAverageDuration" />
                        </span>
                      </Col>
                      {bracesAverageDurationItems.length == 1 &&
                        bracesAverageDurationItems[0].fieldName == "adults" &&
                        ToolStore.numbersToTest.w28 > 0 && (
                          <Col md={6} xl={8}>
                            <Form.Item
                              name="bracesStatisticsbracesAverageDurationadults"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                type="number"
                                suffix={
                                  bracesAverageDurationItems[0].suffix &&
                                  bracesAverageDurationItems[0].suffix
                                }
                                prefix={
                                  bracesAverageDurationItems[0].prefix &&
                                  bracesAverageDurationItems[0].prefix
                                }
                                className={
                                  !WorkflowStore.changed
                                    .bracesStatisticsbracesAverageDurationadults &&
                                  "roi--input-default"
                                }
                                onChange={(e) =>
                                  onChange(
                                    "bracesStatisticsbracesAverageDurationadults",
                                    e
                                  )
                                }
                                onBlur={(e) =>
                                  onBlur(
                                    e,
                                    "bracesStatisticsbracesAverageDurationadults"
                                  )
                                }
                              ></Input>
                            </Form.Item>
                          </Col>
                        )}
                      {bracesAverageDurationItems.length == 1 &&
                        bracesAverageDurationItems[0].fieldName == "teens" &&
                        ToolStore.numbersToTest.w29 > 0 && (
                          <Col md={6} xl={8}>
                            <Form.Item
                              name="bracesStatisticsbracesAverageDurationteens"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                type="number"
                                suffix={
                                  bracesAverageDurationItems[0].suffix &&
                                  bracesAverageDurationItems[0].suffix
                                }
                                prefix={
                                  bracesAverageDurationItems[0].prefix &&
                                  bracesAverageDurationItems[0].prefix
                                }
                                className={
                                  !WorkflowStore.changed
                                    .bracesStatisticsbracesAverageDurationteens &&
                                  "roi--input-default"
                                }
                                onChange={(e) =>
                                  onChange(
                                    "bracesStatisticsbracesAverageDurationteens",
                                    e
                                  )
                                }
                                onBlur={(e) =>
                                  onBlur(
                                    e,
                                    "bracesStatisticsbracesAverageDurationteens"
                                  )
                                }
                              ></Input>
                            </Form.Item>
                          </Col>
                        )}
                    </Row>
                    {ToolStore.conditions.separateTeensAdults &&
                      bracesAverageDurationItems.length > 1 && (
                        <>
                          {ToolStore.numbersToTest.w28 > 0 && (
                            <Row style={{ marginTop: "1vh" }}>
                              <Col xl={2} md={2} />
                              <Col xl={14} md={12}>
                                <span className="roi--label-section roi--border-adults">
                                  <FormattedMessage id="adults" />
                                </span>
                              </Col>
                              <Col xl={8} md={6}>
                                <Form.Item
                                  name="bracesStatisticsbracesAverageDurationadults"
                                  rules={[{ validator: dataSuperior0 }]}
                                >
                                  <Input
                                    prefix={
                                      bracesAverageDurationItems[0].prefix
                                    }
                                    suffix={
                                      bracesAverageDurationItems[0].suffix
                                    }
                                    className={
                                      !WorkflowStore.changed
                                        .bracesStatisticsbracesAverageDurationadults &&
                                      "roi--input-default"
                                    }
                                    onBlur={(e) =>
                                      onBlur(
                                        e,
                                        "bracesStatisticsbracesAverageDurationadults"
                                      )
                                    }
                                    onChange={(e) =>
                                      onChange(
                                        "bracesStatisticsbracesAverageDurationadults",
                                        e
                                      )
                                    }
                                    type="number"
                                  ></Input>
                                </Form.Item>
                              </Col>
                            </Row>
                          )}
                          {ToolStore.numbersToTest.w29 > 0 && (
                            <Row style={{ marginTop: "1vh" }}>
                              <Col xl={2} md={2} />
                              <Col xl={14} md={12}>
                                <span className="roi--label-section roi--border-adults">
                                  <FormattedMessage id="teens" />
                                </span>
                              </Col>
                              <Col xl={8} md={6}>
                                <Form.Item
                                  name="bracesStatisticsbracesAverageDurationteens"
                                  rules={[{ validator: dataSuperior0 }]}
                                >
                                  <Input
                                    prefix={
                                      bracesAverageDurationItems[1].prefix
                                    }
                                    suffix={
                                      bracesAverageDurationItems[1].suffix
                                    }
                                    className={
                                      !WorkflowStore.changed
                                        .bracesStatisticsbracesAverageDurationteens &&
                                      "roi--input-default"
                                    }
                                    onBlur={(e) =>
                                      onBlur(
                                        e,
                                        "bracesStatisticsbracesAverageDurationteens"
                                      )
                                    }
                                    onChange={(e) =>
                                      onChange(
                                        "bracesStatisticsbracesAverageDurationteens",
                                        e
                                      )
                                    }
                                    type="number"
                                  ></Input>
                                </Form.Item>
                              </Col>
                            </Row>
                          )}{" "}
                        </>
                      )}
                  </Col>
                  <Col xl={2} md={0} xs={0}></Col>
                </>
              )}
              {bracesAppointmentsOverTreatmentItems.length > 0 && (
                <>
                  <Col xl={10} md={24}>
                    <Row>
                      <Col xl={2} md={2}>
                        <Tooltip
                          color="#EBEBEA"
                          fontFamily="Gotham"
                          fontSize="20px"
                          style={{ textColor: "#6a6e80" }}
                          placement="rightTop"
                          title={
                            <FormattedMessage id="bracesAppointmentsOverTreatmentTooltip" />
                          }
                        >
                          <img src="/images/icons/bull.svg" />
                        </Tooltip>
                      </Col>
                      <Col md={12} xl={14}>
                        <span
                          className="roi--label-section"
                          style={{ marginTop: "10px" }}
                        >
                          <FormattedMessage id="overTreatment" />
                        </span>
                      </Col>
                      {bracesAppointmentsOverTreatmentItems.length == 1 &&
                        bracesAppointmentsOverTreatmentItems[0].fieldName ==
                          "adults" &&
                        ToolStore.numbersToTest.w28 > 0 && (
                          <Col md={6} xl={8}>
                            <Form.Item
                              name="bracesStatisticsbracesAppointmentsOverTreatmentadults"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                type="number"
                                suffix={
                                  bracesAppointmentsOverTreatmentItems[0]
                                    .suffix &&
                                  bracesAppointmentsOverTreatmentItems[0].suffix
                                }
                                prefix={
                                  bracesAppointmentsOverTreatmentItems[0]
                                    .prefix &&
                                  bracesAppointmentsOverTreatmentItems[0].prefix
                                }
                                className={
                                  !WorkflowStore.changed
                                    .bracesStatisticsbracesAppointmentsOverTreatmentadults &&
                                  "roi--input-default"
                                }
                                onBlur={(e) =>
                                  onBlur(
                                    e,
                                    "bracesStatisticsbracesAppointmentsOverTreatmentadults"
                                  )
                                }
                                onChange={(e) =>
                                  onChange(
                                    "bracesStatisticsbracesAppointmentsOverTreatmentadults",
                                    e
                                  )
                                }
                              ></Input>
                            </Form.Item>
                          </Col>
                        )}
                      {bracesAppointmentsOverTreatmentItems.length == 1 &&
                        bracesAppointmentsOverTreatmentItems[0].fieldName ==
                          "teens" &&
                        ToolStore.numbersToTest.w29 > 0 && (
                          <Col md={6} xl={8}>
                            <Form.Item
                              name="bracesStatisticsbracesAppointmentsOverTreatmentteens"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                type="number"
                                suffix={
                                  bracesAppointmentsOverTreatmentItems[0]
                                    .suffix &&
                                  bracesAppointmentsOverTreatmentItems[0].suffix
                                }
                                prefix={
                                  bracesAppointmentsOverTreatmentItems[0]
                                    .prefix &&
                                  bracesAppointmentsOverTreatmentItems[0].prefix
                                }
                                className={
                                  !WorkflowStore.changed
                                    .bracesStatisticsbracesAppointmentsOverTreatmentteens &&
                                  "roi--input-default"
                                }
                                onBlur={(e) =>
                                  onBlur(
                                    e,
                                    "bracesStatisticsbracesAppointmentsOverTreatmentteens"
                                  )
                                }
                                onChange={(e) =>
                                  onChange(
                                    "bracesStatisticsbracesAppointmentsOverTreatmentteens",
                                    e
                                  )
                                }
                              ></Input>
                            </Form.Item>
                          </Col>
                        )}
                    </Row>
                    {ToolStore.conditions.separateTeensAdults &&
                      bracesAppointmentsOverTreatmentItems.length > 1 && (
                        <>
                          {ToolStore.numbersToTest.w28 > 0 && (
                            <Row style={{ marginTop: "1vh" }}>
                              <Col xl={2} md={2} />
                              <Col xl={14} md={12}>
                                <span className="roi--label-section roi--border-adults">
                                  <FormattedMessage id="adults" />
                                </span>
                              </Col>
                              <Col xl={8} md={6}>
                                <Form.Item
                                  name="bracesStatisticsbracesAppointmentsOverTreatmentadults"
                                  rules={[{ validator: dataSuperior0 }]}
                                >
                                  <Input
                                    prefix={
                                      bracesAppointmentsOverTreatmentItems[0]
                                        .prefix
                                    }
                                    suffix={
                                      bracesAppointmentsOverTreatmentItems[0]
                                        .suffix
                                    }
                                    className={
                                      !WorkflowStore.changed
                                        .bracesStatisticsbracesAppointmentsOverTreatmentadults &&
                                      "roi--input-default"
                                    }
                                    onBlur={(e) =>
                                      onBlur(
                                        e,
                                        "bracesStatisticsbracesAppointmentsOverTreatmentadults"
                                      )
                                    }
                                    onChange={(e) =>
                                      onChange(
                                        "bracesStatisticsbracesAppointmentsOverTreatmentadults",
                                        e
                                      )
                                    }
                                    type="number"
                                  ></Input>
                                </Form.Item>
                              </Col>
                            </Row>
                          )}
                          {ToolStore.numbersToTest.w29 > 0 && (
                            <Row style={{ marginTop: "1vh" }}>
                              <Col xl={2} md={2} />
                              <Col xl={14} md={12}>
                                <span className="roi--label-section roi--border-adults">
                                  <FormattedMessage id="teens" />
                                </span>
                              </Col>
                              <Col xl={8} md={6}>
                                <Form.Item
                                  name="bracesStatisticsbracesAppointmentsOverTreatmentteens"
                                  rules={[{ validator: dataSuperior0 }]}
                                >
                                  <Input
                                    prefix={
                                      bracesAppointmentsOverTreatmentItems[1]
                                        .prefix
                                    }
                                    suffix={
                                      bracesAppointmentsOverTreatmentItems[1]
                                        .suffix
                                    }
                                    className={
                                      !WorkflowStore.changed
                                        .bracesStatisticsbracesAppointmentsOverTreatmentteens &&
                                      "roi--input-default"
                                    }
                                    onBlur={(e) =>
                                      onBlur(
                                        e,
                                        "bracesStatisticsbracesAppointmentsOverTreatmentteens"
                                      )
                                    }
                                    onChange={(e) =>
                                      onChange(
                                        "bracesStatisticsbracesAppointmentsOverTreatmentteens",
                                        e
                                      )
                                    }
                                    type="number"
                                  ></Input>
                                </Form.Item>
                              </Col>
                            </Row>
                          )}
                        </>
                      )}
                  </Col>
                  <Col xl={2} md={0} xs={0}></Col>
                </>
              )}
            </Row>{" "}
            <Row>
              {bracesInadditionItems.length > 0 && (
                <>
                  <Col xl={10} md={24}>
                    <Row>
                      <Col xl={2} md={2}>
                        <Tooltip
                          color="#EBEBEA"
                          fontFamily="Gotham"
                          fontSize="20px"
                          style={{ textColor: "#6a6e80" }}
                          placement="rightTop"
                          title={
                            <FormattedMessage id="bracesInadditionTooltip" />
                          }
                        >
                          <img src="/images/icons/bull.svg" />
                        </Tooltip>
                      </Col>
                      <Col md={12} xl={14}>
                        <span
                          className="roi--label-section"
                          style={{ marginTop: "10px" }}
                        >
                          <FormattedMessage id="bracesInaddition" />
                        </span>
                      </Col>
                      {bracesInadditionItems.length == 1 &&
                        bracesInadditionItems[0].fieldName == "adults" &&
                        ToolStore.numbersToTest.w28 > 0 && (
                          <Col md={6} xl={8}>
                            <Form.Item
                              name="bracesStatisticsbracesInadditionadults"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                type="number"
                                suffix={
                                  bracesInadditionItems[0].suffix &&
                                  bracesInadditionItems[0].suffix
                                }
                                prefix={
                                  bracesInadditionItems[0].prefix &&
                                  bracesInadditionItems[0].prefix
                                }
                                className={
                                  !WorkflowStore.changed
                                    .bracesStatisticsbracesInadditionadults &&
                                  "roi--input-default"
                                }
                                onBlur={(e) =>
                                  onBlur(
                                    e,
                                    "bracesStatisticsbracesInadditionadults"
                                  )
                                }
                                onChange={(e) =>
                                  onChange(
                                    "bracesStatisticsbracesInadditionadults",
                                    e
                                  )
                                }
                              ></Input>
                            </Form.Item>
                          </Col>
                        )}
                      {bracesInadditionItems.length == 1 &&
                        bracesInadditionItems[0].fieldName == "teens" &&
                        ToolStore.numbersToTest.w29 > 0 && (
                          <Col md={6} xl={8}>
                            <Form.Item
                              name="bracesStatisticsbracesInadditionteens"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                type="number"
                                suffix={
                                  bracesInadditionItems[0].suffix &&
                                  bracesInadditionItems[0].suffix
                                }
                                prefix={
                                  bracesInadditionItems[0].prefix &&
                                  bracesInadditionItems[0].prefix
                                }
                                className={
                                  !WorkflowStore.changed
                                    .bracesStatisticsbracesInadditionteens &&
                                  "roi--input-default"
                                }
                                onBlur={(e) =>
                                  onBlur(
                                    e,
                                    "bracesStatisticsbracesInadditionteens"
                                  )
                                }
                                onChange={(e) =>
                                  onChange(
                                    "bracesStatisticsbracesInadditionteens",
                                    e
                                  )
                                }
                              ></Input>
                            </Form.Item>
                          </Col>
                        )}
                    </Row>
                    {ToolStore.conditions.separateTeensAdults &&
                      bracesInadditionItems.length > 1 && (
                        <>
                          {ToolStore.numbersToTest.w28 > 0 && (
                            <Row style={{ marginTop: "1vh" }}>
                              <Col xl={2} md={2} />
                              <Col xl={14} md={12}>
                                <span className="roi--label-section roi--border-adults">
                                  <FormattedMessage id="adults" />
                                </span>
                              </Col>
                              <Col xl={8} md={6}>
                                <Form.Item
                                  name="bracesStatisticsbracesInadditionadults"
                                  rules={[{ validator: dataSuperior0 }]}
                                >
                                  <Input
                                    prefix={bracesInadditionItems[0].prefix}
                                    suffix={bracesInadditionItems[0].suffix}
                                    className={
                                      !WorkflowStore.changed
                                        .bracesStatisticsbracesInadditionadults &&
                                      "roi--input-default"
                                    }
                                    onBlur={(e) =>
                                      onBlur(
                                        e,
                                        "bracesStatisticsbracesInadditionadults"
                                      )
                                    }
                                    onChange={(e) =>
                                      onChange(
                                        "bracesStatisticsbracesInadditionadults",
                                        e
                                      )
                                    }
                                    type="number"
                                  ></Input>
                                </Form.Item>
                              </Col>
                            </Row>
                          )}
                          {ToolStore.numbersToTest.w29 > 0 && (
                            <Row style={{ marginTop: "1vh" }}>
                              <Col xl={2} md={2} />
                              <Col xl={14} md={12}>
                                <span className="roi--label-section roi--border-adults">
                                  <FormattedMessage id="teens" />
                                </span>
                              </Col>
                              <Col xl={8} md={6}>
                                <Form.Item
                                  name="bracesStatisticsbracesInadditionteens"
                                  rules={[{ validator: dataSuperior0 }]}
                                >
                                  <Input
                                    prefix={bracesInadditionItems[1].prefix}
                                    suffix={bracesInadditionItems[1].suffix}
                                    className={
                                      !WorkflowStore.changed
                                        .bracesStatisticsbracesInadditionteens &&
                                      "roi--input-default"
                                    }
                                    onBlur={(e) =>
                                      onBlur(
                                        e,
                                        "bracesStatisticsbracesInadditionteens"
                                      )
                                    }
                                    onChange={(e) =>
                                      onChange(
                                        "bracesStatisticsbracesInadditionteens",
                                        e
                                      )
                                    }
                                    type="number"
                                  ></Input>
                                </Form.Item>
                              </Col>
                            </Row>
                          )}
                        </>
                      )}
                  </Col>
                  <Col xl={2} md={0} xs={0}></Col>
                </>
              )}
            </Row>{" "}
          </Panel>
        </Collapse>
      );
    } else {
      return "";
    }
  };
  const bracesCost = () => {
    const costBracesPractice = toGetElement("bracesCost", "costBracesPractice");
    const consumableTreatment = toGetElement(
      "bracesCost",
      "consumableTreatment"
    );
    if (displayAll) {
      return (
        <Collapse defaultActiveKey={["1"]}>
          <Panel
            header={
              <Row className="dashed" style={{ marginTop: "2vh" }}>
                <span className=" roi--second-collapse-title">
                  <FormattedMessage id="bracesCost" />
                </span>
              </Row>
            }
            key="1"
          >
            <Row>
              <>
                <Col xl={10} md={24}>
                  <Row>
                    <Col xl={2} md={2}>
                      <Tooltip
                        color="#EBEBEA"
                        fontFamily="Gotham"
                        fontSize="20px"
                        style={{ textColor: "#6a6e80" }}
                        placement="rightTop"
                        title={
                          <FormattedMessage id="costBracesPracticeTooltip" />
                        }
                      >
                        <img src="/images/icons/bull.svg" />
                      </Tooltip>
                    </Col>
                    <Col md={12} xl={14}>
                      <span
                        className="roi--label-section"
                        style={{ marginTop: "10px" }}
                      >
                        <FormattedMessage id="costBracesPractice" />
                      </span>
                    </Col>
                    <Col md={6} xl={8}>
                      <Form.Item
                        name="bracesCostcostBracesPractice"
                        rules={[{ validator: dataSuperior0 }]}
                      >
                        <Input
                          type="number"
                          suffix={
                            costBracesPractice.suffix &&
                            costBracesPractice.suffix
                          }
                          prefix={ToolStore.symbol}
                          className={
                            !WorkflowStore.changed
                              .bracesCostcostBracesPractice &&
                            "roi--input-default"
                          }
                          onChange={(e) =>
                            onChange("bracesCostcostBracesPractice", e)
                          }
                          onBlur={(e) =>
                            onBlur(e, "bracesCostcostBracesPractice")
                          }
                        ></Input>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>

                <Col xl={2} md={0} xs={0}></Col>
              </>

              <Col xl={10} md={24} xs={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={
                        <FormattedMessage id="consumableTreatmentTooltip" />
                      }
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="consumableTreatment" />
                    </span>
                  </Col>
                  <Col md={6} xl={8}>
                    <Form.Item
                      name="bracesCostconsumableTreatment"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        type="number"
                        suffix={
                          consumableTreatment.suffix &&
                          consumableTreatment.suffix
                        }
                        prefix={ToolStore.symbol}
                        onChange={(e) =>
                          onChange("bracesCostconsumableTreatment", e)
                        }
                        onBlur={(e) =>
                          onBlur(e, "bracesCostconsumableTreatment")
                        }
                        className={
                          !WorkflowStore.changed
                            .bracesCostconsumableTreatment &&
                          "roi--input-default"
                        }
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Panel>
        </Collapse>
      );
    }
    if (
      (costBracesPractice.display && costBracesPractice.display != -1) ||
      (consumableTreatment.display && consumableTreatment.display != -1)
    ) {
      return (
        <Collapse defaultActiveKey={["1"]}>
          <Panel
            header={
              <Row className="dashed" style={{ marginTop: "2vh" }}>
                <span className=" roi--second-collapse-title">
                  <FormattedMessage id="bracesCost" />
                </span>
              </Row>
            }
            key="1"
          >
            <Row>
              {costBracesPractice.display && costBracesPractice.display != -1 && (
                <>
                  <Col xl={10} md={24}>
                    <Row>
                      <Col xl={2} md={2}>
                        <Tooltip
                          color="#EBEBEA"
                          fontFamily="Gotham"
                          fontSize="20px"
                          style={{ textColor: "#6a6e80" }}
                          placement="rightTop"
                          title={
                            <FormattedMessage id="costBracesPracticeTooltip" />
                          }
                        >
                          <img src="/images/icons/bull.svg" />
                        </Tooltip>
                      </Col>
                      <Col md={12} xl={14}>
                        <span
                          className="roi--label-section"
                          style={{ marginTop: "10px" }}
                        >
                          <FormattedMessage id="costBracesPractice" />
                        </span>
                      </Col>
                      <Col md={6} xl={8}>
                        <Form.Item
                          name="bracesCostcostBracesPractice"
                          rules={[{ validator: dataSuperior0 }]}
                        >
                          <Input
                            type="number"
                            suffix={
                              costBracesPractice.suffix &&
                              costBracesPractice.suffix
                            }
                            prefix={ToolStore.symbol}
                            className={
                              !WorkflowStore.changed
                                .bracesCostcostBracesPractice &&
                              "roi--input-default"
                            }
                            onChange={(e) =>
                              onChange("bracesCostcostBracesPractice", e)
                            }
                            onBlur={(e) =>
                              onBlur(e, "bracesCostcostBracesPractice")
                            }
                          ></Input>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>

                  <Col xl={2} md={0} xs={0}></Col>
                </>
              )}
              {consumableTreatment.display &&
                consumableTreatment.display != -1 && (
                  <Col xl={10} md={24} xs={24}>
                    <Row>
                      <Col xl={2} md={2}>
                        <Tooltip
                          color="#EBEBEA"
                          fontFamily="Gotham"
                          fontSize="20px"
                          style={{ textColor: "#6a6e80" }}
                          placement="rightTop"
                          title={
                            <FormattedMessage id="consumableTreatmentTooltip" />
                          }
                        >
                          <img src="/images/icons/bull.svg" />
                        </Tooltip>
                      </Col>
                      <Col md={12} xl={14}>
                        <span
                          className="roi--label-section"
                          style={{ marginTop: "10px" }}
                        >
                          <FormattedMessage id="consumableTreatment" />
                        </span>
                      </Col>
                      <Col md={6} xl={8}>
                        <Form.Item
                          name="bracesCostconsumableTreatment"
                          rules={[{ validator: dataSuperior0 }]}
                        >
                          <Input
                            type="number"
                            suffix={
                              consumableTreatment.suffix &&
                              consumableTreatment.suffix
                            }
                            prefix={ToolStore.symbol}
                            onChange={(e) =>
                              onChange("bracesCostconsumableTreatment", e)
                            }
                            onBlur={(e) =>
                              onBlur(e, "bracesCostconsumableTreatment")
                            }
                            className={
                              !WorkflowStore.changed
                                .bracesCostconsumableTreatment &&
                              "roi--input-default"
                            }
                          ></Input>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                )}
            </Row>
          </Panel>
        </Collapse>
      );
    } else {
      return "";
    }
  };

  const bracesTimeSpent = () => {
    const timeSpentCheckupAppointement = toGetElement(
      "bracesTimeSpent",
      "timeSpentCheckupAppointement"
    );

    const dentalAssistant = toGetElement("bracesTimeSpent", "dentalAssistant");
    const treatmentCoordinator = toGetElement(
      "bracesTimeSpent",
      "treatmentCoordinator"
    );
    const frontDesk = toGetElement("bracesTimeSpent", "frontDesk");
    const dentalAssistantItems = toGetSubElements(dentalAssistant);
    const treatmentCoordinatorItems = toGetSubElements(treatmentCoordinator);
    const frontDeskItems = toGetSubElements(frontDesk);

    if (displayAll) {
      return (
        <Collapse defaultActiveKey={["1"]}>
          <Panel
            header={
              <Row className="dashed" style={{ marginTop: "2vh" }}>
                <span className=" roi--second-collapse-title">
                  <FormattedMessage id="bracesTimeSpent" />
                </span>
              </Row>
            }
            key="1"
          >
            <Row>
              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={
                        <FormattedMessage id="timeSpentCheckupAppointementTooltip" />
                      }
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="timeSpentCheckupAppointement" />
                    </span>
                  </Col>
                  <Col md={6} xl={8}>
                    <Form.Item
                      name="bracesTimeSpenttimeSpentCheckupAppointement"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        type="number"
                        suffix={
                          timeSpentCheckupAppointement.suffix &&
                          timeSpentCheckupAppointement.suffix
                        }
                        prefix={
                          timeSpentCheckupAppointement.prefix &&
                          timeSpentCheckupAppointement.prefix
                        }
                        className={
                          !WorkflowStore.changed
                            .bracesTimeSpenttimeSpentCheckupAppointement &&
                          "roi--input-default"
                        }
                        onChange={(e) =>
                          onChange(
                            "bracesTimeSpenttimeSpentCheckupAppointement",
                            e
                          )
                        }
                        onBlur={(e) =>
                          onBlur(
                            e,
                            "bracesTimeSpenttimeSpentCheckupAppointement"
                          )
                        }
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xl={2} md={0} xs={0}></Col>

              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={<FormattedMessage id="dentalAssistantTooltip" />}
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage
                        id={
                          ToolStore.conditions.separateStaffRole
                            ? "dentalAssistant"
                            : "staffTimeSpents"
                        }
                      />
                    </span>
                  </Col>
                </Row>

                <Row style={{ marginTop: "1vh" }}>
                  <Col xl={2} md={2} />
                  <Col xl={14} md={12}>
                    <span className="roi--label-section roi--border-adults">
                      <FormattedMessage id="checkupAppointement" />
                    </span>
                  </Col>
                  <Col xl={8} md={6}>
                    <Form.Item
                      name="bracesTimeSpentdentalAssistantcheckupAppointement"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        prefix={dentalAssistantItems[0].prefix}
                        suffix={dentalAssistantItems[0].suffix}
                        className={
                          !WorkflowStore.changed
                            .bracesTimeSpentdentalAssistantcheckupAppointement &&
                          "roi--input-default"
                        }
                        onBlur={(e) =>
                          onBlur(
                            e,
                            "bracesTimeSpentdentalAssistantcheckupAppointement"
                          )
                        }
                        onChange={(e) =>
                          onChange(
                            "bracesTimeSpentdentalAssistantcheckupAppointement",
                            e
                          )
                        }
                        type="number"
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>

                <Row style={{ marginTop: "1vh" }}>
                  <Col xl={2} md={2} />
                  <Col xl={14} md={12}>
                    <span className="roi--label-section roi--border-adults">
                      <FormattedMessage id="prepareAppointment" />
                    </span>
                  </Col>
                  <Col xl={8} md={6}>
                    <Form.Item
                      name="bracesTimeSpentdentalAssistantprepareAppointment"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        prefix={dentalAssistantItems[1].prefix}
                        suffix={dentalAssistantItems[1].suffix}
                        className={
                          !WorkflowStore.changed
                            .bracesTimeSpentdentalAssistantprepareAppointment &&
                          "roi--input-default"
                        }
                        onBlur={(e) =>
                          onBlur(
                            e,
                            "bracesTimeSpentdentalAssistantprepareAppointment"
                          )
                        }
                        onChange={(e) =>
                          onChange(
                            "bracesTimeSpentdentalAssistantprepareAppointment",
                            e
                          )
                        }
                        type="number"
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xl={2} md={0} xs={0}></Col>
            </Row>

            <Row>
              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={
                        <FormattedMessage id="treatmentCoordinatorTooltip" />
                      }
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="treatmentCoordinator" />
                    </span>
                  </Col>
                </Row>

                <>
                  <Row style={{ marginTop: "1vh" }}>
                    <Col xl={2} md={2} />
                    <Col xl={14} md={12}>
                      <span className="roi--label-section roi--border-adults">
                        <FormattedMessage id="checkupAppointement" />
                      </span>
                    </Col>
                    <Col xl={8} md={6}>
                      <Form.Item
                        name="bracesTimeSpenttreatmentCoordinatorcheckupAppointement"
                        rules={[{ validator: dataSuperior0 }]}
                      >
                        <Input
                          prefix={treatmentCoordinatorItems[0].prefix}
                          suffix={treatmentCoordinatorItems[0].suffix}
                          className={
                            !WorkflowStore.changed
                              .bracesTimeSpenttreatmentCoordinatorcheckupAppointement &&
                            "roi--input-default"
                          }
                          onBlur={(e) =>
                            onBlur(
                              e,
                              "bracesTimeSpenttreatmentCoordinatorcheckupAppointement"
                            )
                          }
                          onChange={(e) =>
                            onChange(
                              "bracesTimeSpenttreatmentCoordinatorcheckupAppointement",
                              e
                            )
                          }
                          type="number"
                        ></Input>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row style={{ marginTop: "1vh" }}>
                    <Col xl={2} md={2} />
                    <Col xl={14} md={12}>
                      <span className="roi--label-section roi--border-adults">
                        <FormattedMessage id="prepareAppointment" />
                      </span>
                    </Col>
                    <Col xl={8} md={6}>
                      <Form.Item
                        name="bracesTimeSpenttreatmentCoordinatorprepareAppointment"
                        rules={[{ validator: dataSuperior0 }]}
                      >
                        <Input
                          prefix={treatmentCoordinatorItems[1].prefix}
                          suffix={treatmentCoordinatorItems[1].suffix}
                          className={
                            !WorkflowStore.changed
                              .bracesTimeSpenttreatmentCoordinatorprepareAppointment &&
                            "roi--input-default"
                          }
                          onBlur={(e) =>
                            onBlur(
                              e,
                              "bracesTimeSpenttreatmentCoordinatorprepareAppointment"
                            )
                          }
                          onChange={(e) =>
                            onChange(
                              "bracesTimeSpenttreatmentCoordinatorprepareAppointment",
                              e
                            )
                          }
                          type="number"
                        ></Input>
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              </Col>
              <Col xl={2} md={0} xs={0}></Col>

              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={<FormattedMessage id="frontDeskTooltip" />}
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="frontDesk" />
                    </span>
                  </Col>
                </Row>

                <>
                  <Row style={{ marginTop: "1vh" }}>
                    <Col xl={2} md={2} />
                    <Col xl={14} md={12}>
                      <span className="roi--label-section roi--border-adults">
                        <FormattedMessage id="checkupAppointement" />
                      </span>
                    </Col>
                    <Col xl={8} md={6}>
                      <Form.Item
                        name="bracesTimeSpentfrontDeskcheckupAppointement"
                        rules={[{ validator: dataSuperior0 }]}
                      >
                        <Input
                          prefix={frontDeskItems[0].prefix}
                          suffix={frontDeskItems[0].suffix}
                          className={
                            !WorkflowStore.changed
                              .bracesTimeSpentfrontDeskcheckupAppointement &&
                            "roi--input-default"
                          }
                          onBlur={(e) =>
                            onBlur(
                              e,
                              "bracesTimeSpentfrontDeskcheckupAppointement"
                            )
                          }
                          onChange={(e) =>
                            onChange(
                              "bracesTimeSpentfrontDeskcheckupAppointement",
                              e
                            )
                          }
                          type="number"
                        ></Input>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row style={{ marginTop: "1vh" }}>
                    <Col xl={2} md={2} />
                    <Col xl={14} md={12}>
                      <span className="roi--label-section roi--border-adults">
                        <FormattedMessage id="takeAppointment" />
                      </span>
                    </Col>
                    <Col xl={8} md={6}>
                      <Form.Item
                        name="bracesTimeSpentfrontDesktakeAppointment"
                        rules={[{ validator: dataSuperior0 }]}
                      >
                        <Input
                          prefix={frontDeskItems[1].prefix}
                          suffix={frontDeskItems[1].suffix}
                          className={
                            !WorkflowStore.changed
                              .bracesTimeSpentfrontDesktakeAppointment &&
                            "roi--input-default"
                          }
                          onBlur={(e) =>
                            onBlur(e, "bracesTimeSpentfrontDesktakeAppointment")
                          }
                          onChange={(e) =>
                            onChange(
                              "bracesTimeSpentfrontDesktakeAppointment",
                              e
                            )
                          }
                          type="number"
                        ></Input>
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              </Col>
              <Col xl={2} md={0} xs={0}></Col>
            </Row>
          </Panel>
        </Collapse>
      );
    }
    if (
      (ToolStore.conditions.showHourly &&
        timeSpentCheckupAppointement.display &&
        timeSpentCheckupAppointement.display != -1) ||
      dentalAssistantItems.length > 0 ||
      (ToolStore.conditions.separateStaffRole &&
        treatmentCoordinatorItems.length > 0) ||
      (ToolStore.conditions.separateStaffRole && frontDeskItems.length > 0)
    ) {
      return (
        <Collapse defaultActiveKey={["1"]}>
          <Panel
            header={
              <Row className="dashed" style={{ marginTop: "2vh" }}>
                <span className=" roi--second-collapse-title">
                  <FormattedMessage id="bracesTimeSpent" />
                </span>
              </Row>
            }
            key="1"
          >
            <Row>
              {ToolStore.conditions.showHourly &&
                timeSpentCheckupAppointement.display &&
                timeSpentCheckupAppointement.display != -1 && (
                  <>
                    <Col xl={10} md={24}>
                      <Row>
                        <Col xl={2} md={2}>
                          <Tooltip
                            color="#EBEBEA"
                            fontFamily="Gotham"
                            fontSize="20px"
                            style={{ textColor: "#6a6e80" }}
                            placement="rightTop"
                            title={
                              <FormattedMessage id="timeSpentCheckupAppointementTooltip" />
                            }
                          >
                            <img src="/images/icons/bull.svg" />
                          </Tooltip>
                        </Col>
                        <Col md={12} xl={14}>
                          <span
                            className="roi--label-section"
                            style={{ marginTop: "10px" }}
                          >
                            <FormattedMessage id="timeSpentCheckupAppointement" />
                          </span>
                        </Col>
                        <Col md={6} xl={8}>
                          <Form.Item
                            name="bracesTimeSpenttimeSpentCheckupAppointement"
                            rules={[{ validator: dataSuperior0 }]}
                          >
                            <Input
                              type="number"
                              suffix={
                                timeSpentCheckupAppointement.suffix &&
                                timeSpentCheckupAppointement.suffix
                              }
                              prefix={
                                timeSpentCheckupAppointement.prefix &&
                                timeSpentCheckupAppointement.prefix
                              }
                              className={
                                !WorkflowStore.changed
                                  .bracesTimeSpenttimeSpentCheckupAppointement &&
                                "roi--input-default"
                              }
                              onChange={(e) =>
                                onChange(
                                  "bracesTimeSpenttimeSpentCheckupAppointement",
                                  e
                                )
                              }
                              onBlur={(e) =>
                                onBlur(
                                  e,
                                  "bracesTimeSpenttimeSpentCheckupAppointement"
                                )
                              }
                            ></Input>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                    <Col xl={2} md={0} xs={0}></Col>
                  </>
                )}
              {dentalAssistantItems.length > 0 && (
                <>
                  <Col xl={10} md={24}>
                    <Row>
                      <Col xl={2} md={2}>
                        <Tooltip
                          color="#EBEBEA"
                          fontFamily="Gotham"
                          fontSize="20px"
                          style={{ textColor: "#6a6e80" }}
                          placement="rightTop"
                          title={
                            <FormattedMessage id="dentalAssistantTooltip" />
                          }
                        >
                          <img src="/images/icons/bull.svg" />
                        </Tooltip>
                      </Col>
                      <Col md={12} xl={14}>
                        <span
                          className="roi--label-section"
                          style={{ marginTop: "10px" }}
                        >
                          <FormattedMessage
                            id={
                              ToolStore.conditions.separateStaffRole
                                ? "dentalAssistant"
                                : "staffTimeSpents"
                            }
                          />
                        </span>
                      </Col>
                      {!ToolStore.conditions.separateStaffRole && (
                        <Col md={6} xl={8}>
                          <Form.Item
                            name="bracesTimeSpentdentalAssistantcheckupAppointement"
                            rules={[{ validator: dataSuperior0 }]}
                          >
                            <Input
                              type="number"
                              suffix={
                                dentalAssistantItems[0].suffix &&
                                dentalAssistantItems[0].suffix
                              }
                              prefix={
                                dentalAssistantItems[0].prefix &&
                                dentalAssistantItems[0].prefix
                              }
                              className={
                                !WorkflowStore.changed
                                  .bracesTimeSpentdentalAssistantcheckupAppointement &&
                                "roi--input-default"
                              }
                              onChange={(e) =>
                                onChange(
                                  "bracesTimeSpentdentalAssistantcheckupAppointement",
                                  e
                                )
                              }
                              onBlur={(e) =>
                                onBlur(
                                  e,
                                  "bracesTimeSpentdentalAssistantcheckupAppointement"
                                )
                              }
                            ></Input>
                          </Form.Item>
                        </Col>
                      )}
                    </Row>
                    {ToolStore.conditions.separateStaffRole && (
                      <>
                        <Row style={{ marginTop: "1vh" }}>
                          <Col xl={2} md={2} />
                          <Col xl={14} md={12}>
                            <span className="roi--label-section roi--border-adults">
                              <FormattedMessage id="checkupAppointement" />
                            </span>
                          </Col>
                          <Col xl={8} md={6}>
                            <Form.Item
                              name="bracesTimeSpentdentalAssistantcheckupAppointement"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                prefix={dentalAssistantItems[0].prefix}
                                suffix={dentalAssistantItems[0].suffix}
                                className={
                                  !WorkflowStore.changed
                                    .bracesTimeSpentdentalAssistantcheckupAppointement &&
                                  "roi--input-default"
                                }
                                onBlur={(e) =>
                                  onBlur(
                                    e,
                                    "bracesTimeSpentdentalAssistantcheckupAppointement"
                                  )
                                }
                                onChange={(e) =>
                                  onChange(
                                    "bracesTimeSpentdentalAssistantcheckupAppointement",
                                    e
                                  )
                                }
                                type="number"
                              ></Input>
                            </Form.Item>
                          </Col>
                        </Row>

                        <Row style={{ marginTop: "1vh" }}>
                          <Col xl={2} md={2} />
                          <Col xl={14} md={12}>
                            <span className="roi--label-section roi--border-adults">
                              <FormattedMessage id="prepareAppointment" />
                            </span>
                          </Col>
                          <Col xl={8} md={6}>
                            <Form.Item
                              name="bracesTimeSpentdentalAssistantprepareAppointment"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                prefix={dentalAssistantItems[1].prefix}
                                suffix={dentalAssistantItems[1].suffix}
                                className={
                                  !WorkflowStore.changed
                                    .bracesTimeSpentdentalAssistantprepareAppointment &&
                                  "roi--input-default"
                                }
                                onBlur={(e) =>
                                  onBlur(
                                    e,
                                    "bracesTimeSpentdentalAssistantprepareAppointment"
                                  )
                                }
                                onChange={(e) =>
                                  onChange(
                                    "bracesTimeSpentdentalAssistantprepareAppointment",
                                    e
                                  )
                                }
                                type="number"
                              ></Input>
                            </Form.Item>
                          </Col>
                        </Row>
                      </>
                    )}
                  </Col>
                  <Col xl={2} md={0} xs={0}></Col>
                </>
              )}
            </Row>
            <Row>
              {ToolStore.conditions.separateStaffRole &&
                treatmentCoordinatorItems.length > 0 && (
                  <>
                    <Col xl={10} md={24}>
                      <Row>
                        <Col xl={2} md={2}>
                          <Tooltip
                            color="#EBEBEA"
                            fontFamily="Gotham"
                            fontSize="20px"
                            style={{ textColor: "#6a6e80" }}
                            placement="rightTop"
                            title={
                              <FormattedMessage id="treatmentCoordinatorTooltip" />
                            }
                          >
                            <img src="/images/icons/bull.svg" />
                          </Tooltip>
                        </Col>
                        <Col md={12} xl={14}>
                          <span
                            className="roi--label-section"
                            style={{ marginTop: "10px" }}
                          >
                            <FormattedMessage id="treatmentCoordinator" />
                          </span>
                        </Col>
                      </Row>

                      <>
                        <Row style={{ marginTop: "1vh" }}>
                          <Col xl={2} md={2} />
                          <Col xl={14} md={12}>
                            <span className="roi--label-section roi--border-adults">
                              <FormattedMessage id="checkupAppointement" />
                            </span>
                          </Col>
                          <Col xl={8} md={6}>
                            <Form.Item
                              name="bracesTimeSpenttreatmentCoordinatorcheckupAppointement"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                prefix={treatmentCoordinatorItems[0].prefix}
                                suffix={treatmentCoordinatorItems[0].suffix}
                                className={
                                  !WorkflowStore.changed
                                    .bracesTimeSpenttreatmentCoordinatorcheckupAppointement &&
                                  "roi--input-default"
                                }
                                onBlur={(e) =>
                                  onBlur(
                                    e,
                                    "bracesTimeSpenttreatmentCoordinatorcheckupAppointement"
                                  )
                                }
                                onChange={(e) =>
                                  onChange(
                                    "bracesTimeSpenttreatmentCoordinatorcheckupAppointement",
                                    e
                                  )
                                }
                                type="number"
                              ></Input>
                            </Form.Item>
                          </Col>
                        </Row>

                        <Row style={{ marginTop: "1vh" }}>
                          <Col xl={2} md={2} />
                          <Col xl={14} md={12}>
                            <span className="roi--label-section roi--border-adults">
                              <FormattedMessage id="prepareAppointment" />
                            </span>
                          </Col>
                          <Col xl={8} md={6}>
                            <Form.Item
                              name="bracesTimeSpenttreatmentCoordinatorprepareAppointment"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                prefix={treatmentCoordinatorItems[1].prefix}
                                suffix={treatmentCoordinatorItems[1].suffix}
                                className={
                                  !WorkflowStore.changed
                                    .bracesTimeSpenttreatmentCoordinatorprepareAppointment &&
                                  "roi--input-default"
                                }
                                onBlur={(e) =>
                                  onBlur(
                                    e,
                                    "bracesTimeSpenttreatmentCoordinatorprepareAppointment"
                                  )
                                }
                                onChange={(e) =>
                                  onChange(
                                    "bracesTimeSpenttreatmentCoordinatorprepareAppointment",
                                    e
                                  )
                                }
                                type="number"
                              ></Input>
                            </Form.Item>
                          </Col>
                        </Row>
                      </>
                    </Col>
                    <Col xl={2} md={0} xs={0}></Col>
                  </>
                )}
              {ToolStore.conditions.separateStaffRole &&
                frontDeskItems.length > 0 && (
                  <>
                    <Col xl={10} md={24}>
                      <Row>
                        <Col xl={2} md={2}>
                          <Tooltip
                            color="#EBEBEA"
                            fontFamily="Gotham"
                            fontSize="20px"
                            style={{ textColor: "#6a6e80" }}
                            placement="rightTop"
                            title={<FormattedMessage id="frontDeskTooltip" />}
                          >
                            <img src="/images/icons/bull.svg" />
                          </Tooltip>
                        </Col>
                        <Col md={12} xl={14}>
                          <span
                            className="roi--label-section"
                            style={{ marginTop: "10px" }}
                          >
                            <FormattedMessage id="frontDesk" />
                          </span>
                        </Col>
                      </Row>

                      <>
                        <Row style={{ marginTop: "1vh" }}>
                          <Col xl={2} md={2} />
                          <Col xl={14} md={12}>
                            <span className="roi--label-section roi--border-adults">
                              <FormattedMessage id="checkupAppointement" />
                            </span>
                          </Col>
                          <Col xl={8} md={6}>
                            <Form.Item
                              name="bracesTimeSpentfrontDeskcheckupAppointement"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                prefix={frontDeskItems[0].prefix}
                                suffix={frontDeskItems[0].suffix}
                                className={
                                  !WorkflowStore.changed
                                    .bracesTimeSpentfrontDeskcheckupAppointement &&
                                  "roi--input-default"
                                }
                                onBlur={(e) =>
                                  onBlur(
                                    e,
                                    "bracesTimeSpentfrontDeskcheckupAppointement"
                                  )
                                }
                                onChange={(e) =>
                                  onChange(
                                    "bracesTimeSpentfrontDeskcheckupAppointement",
                                    e
                                  )
                                }
                                type="number"
                              ></Input>
                            </Form.Item>
                          </Col>
                        </Row>

                        <Row style={{ marginTop: "1vh" }}>
                          <Col xl={2} md={2} />
                          <Col xl={14} md={12}>
                            <span className="roi--label-section roi--border-adults">
                              <FormattedMessage id="takeAppointment" />
                            </span>
                          </Col>
                          <Col xl={8} md={6}>
                            <Form.Item
                              name="bracesTimeSpentfrontDesktakeAppointment"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                prefix={frontDeskItems[1].prefix}
                                suffix={frontDeskItems[1].suffix}
                                className={
                                  !WorkflowStore.changed
                                    .bracesTimeSpentfrontDesktakeAppointment &&
                                  "roi--input-default"
                                }
                                onBlur={(e) =>
                                  onBlur(
                                    e,
                                    "bracesTimeSpentfrontDesktakeAppointment"
                                  )
                                }
                                onChange={(e) =>
                                  onChange(
                                    "bracesTimeSpentfrontDesktakeAppointment",
                                    e
                                  )
                                }
                                type="number"
                              ></Input>
                            </Form.Item>
                          </Col>
                        </Row>
                      </>
                    </Col>
                    <Col xl={2} md={0} xs={0}></Col>
                  </>
                )}
            </Row>
          </Panel>
        </Collapse>
      );
    } else {
      return "";
    }
  };
  const retention = () => {
    const percentageComingBack = toGetElement(
      "retention",
      "percentageComingBack"
    );

    const averageVistis = toGetElement("retention", "averageVistis");
    const labFee = toGetElement("retention", "labFee");
    if (displayAll) {
      return (
        <Collapse defaultActiveKey={["1"]}>
          <Panel
            header={
              <Row className="dashed" style={{ marginTop: "2vh" }}>
                <span className=" roi--second-collapse-title">
                  <FormattedMessage id="retention" />
                </span>
              </Row>
            }
            key="1"
          >
            <Row>
              <>
                <Col xl={10} md={24}>
                  <Row>
                    <Col xl={2} md={2}>
                      <Tooltip
                        color="#EBEBEA"
                        fontFamily="Gotham"
                        fontSize="20px"
                        style={{ textColor: "#6a6e80" }}
                        placement="rightTop"
                        title={
                          <FormattedMessage id="percentageComingBackTooltip" />
                        }
                      >
                        <img src="/images/icons/bull.svg" />
                      </Tooltip>
                    </Col>
                    <Col md={12} xl={14}>
                      <span
                        className="roi--label-section"
                        style={{ marginTop: "10px" }}
                      >
                        <FormattedMessage id="percentageComingBack" />
                      </span>
                    </Col>
                    <Col md={6} xl={8}>
                      <Form.Item
                        name="retentionpercentageComingBack"
                        rules={[{ validator: dataSuperior0 }]}
                      >
                        <Input
                          type="number"
                          suffix={
                            percentageComingBack.suffix &&
                            percentageComingBack.suffix
                          }
                          prefix={
                            percentageComingBack.prefix &&
                            percentageComingBack.prefix
                          }
                          className={
                            !WorkflowStore.changed
                              .retentionpercentageComingBack &&
                            "roi--input-default"
                          }
                          onChange={(e) =>
                            onChange("retentionpercentageComingBack", e)
                          }
                          onBlur={(e) =>
                            onBlur(e, "retentionpercentageComingBack")
                          }
                        ></Input>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>

                <Col xl={2} md={0} xs={0}></Col>
              </>

              <Col xl={10} md={24} xs={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={<FormattedMessage id="averageVistisTooltip" />}
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="averageVistis" />
                    </span>
                  </Col>
                  <Col md={6} xl={8}>
                    <Form.Item
                      name="retentionaverageVistis"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        type="number"
                        suffix={averageVistis.suffix && averageVistis.suffix}
                        prefix={averageVistis.prefix && averageVistis.prefix}
                        onChange={(e) => onChange("retentionaverageVistis", e)}
                        onBlur={(e) => onBlur(e, "retentionaverageVistis")}
                        className={
                          !WorkflowStore.changed.retentionaverageVistis &&
                          "roi--input-default"
                        }
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xl={10} md={24} xs={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={<FormattedMessage id="labFeeTooltip" />}
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="labFee" />
                    </span>
                  </Col>
                  <Col md={6} xl={8}>
                    <Form.Item
                      name="retentionlabFee"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        type="number"
                        suffix={labFee.suffix && labFee.suffix}
                        prefix={ToolStore.symbol}
                        onChange={(e) => onChange("retentionlabFee", e)}
                        onBlur={(e) => onBlur(e, "retentionlabFee")}
                        className={
                          !WorkflowStore.changed.retentionlabFee &&
                          "roi--input-default"
                        }
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Panel>
        </Collapse>
      );
    }
    if (
      (percentageComingBack.display && percentageComingBack.display != -1) ||
      (averageVistis.display != -1 && averageVistis.display) ||
      (labFee.display != -1 && labFee.display)
    ) {
      return (
        <Collapse defaultActiveKey={["1"]}>
          <Panel
            header={
              <Row className="dashed" style={{ marginTop: "2vh" }}>
                <span className=" roi--second-collapse-title">
                  <FormattedMessage id="retention" />
                </span>
              </Row>
            }
            key="1"
          >
            <Row>
              {percentageComingBack.display &&
                percentageComingBack.display != -1 && (
                  <>
                    <Col xl={10} md={24}>
                      <Row>
                        <Col xl={2} md={2}>
                          <Tooltip
                            color="#EBEBEA"
                            fontFamily="Gotham"
                            fontSize="20px"
                            style={{ textColor: "#6a6e80" }}
                            placement="rightTop"
                            title={
                              <FormattedMessage id="percentageComingBackTooltip" />
                            }
                          >
                            <img src="/images/icons/bull.svg" />
                          </Tooltip>
                        </Col>
                        <Col md={12} xl={14}>
                          <span
                            className="roi--label-section"
                            style={{ marginTop: "10px" }}
                          >
                            <FormattedMessage id="percentageComingBack" />
                          </span>
                        </Col>
                        <Col md={6} xl={8}>
                          <Form.Item
                            name="retentionpercentageComingBack"
                            rules={[{ validator: dataSuperior0 }]}
                          >
                            <Input
                              type="number"
                              suffix={
                                percentageComingBack.suffix &&
                                percentageComingBack.suffix
                              }
                              prefix={
                                percentageComingBack.prefix &&
                                percentageComingBack.prefix
                              }
                              className={
                                !WorkflowStore.changed
                                  .retentionpercentageComingBack &&
                                "roi--input-default"
                              }
                              onChange={(e) =>
                                onChange("retentionpercentageComingBack", e)
                              }
                              onBlur={(e) =>
                                onBlur(e, "retentionpercentageComingBack")
                              }
                            ></Input>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>

                    <Col xl={2} md={0} xs={0}></Col>
                  </>
                )}
              {(averageVistis.display && averageVistis.display != -1) ||
                (displayAll && (
                  <Col xl={10} md={24} xs={24}>
                    <Row>
                      <Col xl={2} md={2}>
                        <Tooltip
                          color="#EBEBEA"
                          fontFamily="Gotham"
                          fontSize="20px"
                          style={{ textColor: "#6a6e80" }}
                          placement="rightTop"
                          title={<FormattedMessage id="averageVistisTooltip" />}
                        >
                          <img src="/images/icons/bull.svg" />
                        </Tooltip>
                      </Col>
                      <Col md={12} xl={14}>
                        <span
                          className="roi--label-section"
                          style={{ marginTop: "10px" }}
                        >
                          <FormattedMessage id="averageVistis" />
                        </span>
                      </Col>
                      <Col md={6} xl={8}>
                        <Form.Item
                          name="retentionaverageVistis"
                          rules={[{ validator: dataSuperior0 }]}
                        >
                          <Input
                            type="number"
                            suffix={
                              averageVistis.suffix && averageVistis.suffix
                            }
                            prefix={
                              averageVistis.prefix && averageVistis.prefix
                            }
                            onChange={(e) =>
                              onChange("retentionaverageVistis", e)
                            }
                            onBlur={(e) => onBlur(e, "retentionaverageVistis")}
                            className={
                              !WorkflowStore.changed.retentionaverageVistis &&
                              "roi--input-default"
                            }
                          ></Input>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                ))}
            </Row>
            <Row>
              {labFee.display && labFee.display != -1 && (
                <Col xl={10} md={24} xs={24}>
                  <Row>
                    <Col xl={2} md={2}>
                      <Tooltip
                        color="#EBEBEA"
                        fontFamily="Gotham"
                        fontSize="20px"
                        style={{ textColor: "#6a6e80" }}
                        placement="rightTop"
                        title={<FormattedMessage id="labFeeTooltip" />}
                      >
                        <img src="/images/icons/bull.svg" />
                      </Tooltip>
                    </Col>
                    <Col md={12} xl={14}>
                      <span
                        className="roi--label-section"
                        style={{ marginTop: "10px" }}
                      >
                        <FormattedMessage id="labFee" />
                      </span>
                    </Col>
                    <Col md={6} xl={8}>
                      <Form.Item
                        name="retentionlabFee"
                        rules={[{ validator: dataSuperior0 }]}
                      >
                        <Input
                          type="number"
                          suffix={labFee.suffix && labFee.suffix}
                          prefix={ToolStore.symbol}
                          onChange={(e) => onChange("retentionlabFee", e)}
                          onBlur={(e) => onBlur(e, "retentionlabFee")}
                          className={
                            !WorkflowStore.changed.retentionlabFee &&
                            "roi--input-default"
                          }
                        ></Input>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              )}
            </Row>
          </Panel>
        </Collapse>
      );
    } else {
      return "";
    }
  };
  const relapseElements = () => {
    const averageRelapse = toGetElement("relapse", "averageRelapse");
    const averageRelapseItems = toGetSubElements(averageRelapse);
    if (displayAll) {
      return (
        <Collapse defaultActiveKey={["1"]}>
          <Panel
            header={
              <Row className="dashed" style={{ marginTop: "2vh" }}>
                <span className="roi--second-collapse-title">
                  <FormattedMessage id="relapse" />
                </span>
              </Row>
            }
            key="1"
          >
            <Row>
              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={<FormattedMessage id="averageRelapseTooltip" />}
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="averageRelapse" />
                    </span>
                  </Col>
                </Row>

                <Row style={{ marginTop: "1vh" }}>
                  <Col xl={2} md={2} />
                  <Col xl={14} md={12}>
                    <span className="roi--label-section roi--border-adults">
                      <FormattedMessage id="adults" />
                    </span>
                  </Col>
                  <Col xl={8} md={6}>
                    <Form.Item
                      name="relapseaverageRelapseadults"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        prefix={averageRelapseItems[0].prefix}
                        suffix={averageRelapseItems[0].suffix}
                        className={
                          !WorkflowStore.changed.relapseaverageRelapseadults &&
                          "roi--input-default"
                        }
                        onBlur={(e) => onBlur(e, "relapseaverageRelapseadults")}
                        onChange={(e) =>
                          onChange("relapseaverageRelapseadults", e)
                        }
                        type="number"
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>

                <Row style={{ marginTop: "1vh" }}>
                  <Col xl={2} md={2} />
                  <Col xl={14} md={12}>
                    <span className="roi--label-section roi--border-adults">
                      <FormattedMessage id="teens" />
                    </span>
                  </Col>
                  <Col xl={8} md={6}>
                    <Form.Item
                      name="relapseaverageRelapseteens"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        prefix={averageRelapseItems[1].prefix}
                        suffix={averageRelapseItems[1].suffix}
                        className={
                          !WorkflowStore.changed.relapseaverageRelapseteens &&
                          "roi--input-default"
                        }
                        onBlur={(e) => onBlur(e, "relapseaverageRelapseteens")}
                        onChange={(e) =>
                          onChange("relapseaverageRelapseteens", e)
                        }
                        type="number"
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xl={2} md={0} xs={0}></Col>
              {/*   <Col xl={10} md={24} xs={24}>
                <Row>
                  <Col xl={2} md={2}></Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="targetAnnualGrowth" />
                    </span>
                  </Col>
                  <Col md={6} xl={8}>
                    <Form.Item
                      name="relapsetargetAnnualGrowth"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        type="number"
                        suffix={
                          targetAnnualGrowth.suffix && targetAnnualGrowth.suffix
                        }
                        onChange={(e) => onChange("targetAnnualGrowth", e)}
                        onBlur={(e) => onBlur(e, "targetAnnualGrowth")}
                        className={
                          !WorkflowStore.changed.targetAnnualGrowth &&
                          "roi--input-default"
                        }
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
           */}{" "}
            </Row>{" "}
          </Panel>
        </Collapse>
      );
    }
    if (averageRelapseItems.length > 0) {
      return (
        <Collapse defaultActiveKey={["1"]}>
          <Panel
            header={
              <Row className="dashed" style={{ marginTop: "2vh" }}>
                <span className="roi--second-collapse-title">
                  <FormattedMessage id="relapse" />
                </span>
              </Row>
            }
            key="1"
          >
            <Row>
              {averageRelapseItems.length > 0 && (
                <>
                  <Col xl={10} md={24}>
                    <Row>
                      <Col xl={2} md={2}>
                        <Tooltip
                          color="#EBEBEA"
                          fontFamily="Gotham"
                          fontSize="20px"
                          style={{ textColor: "#6a6e80" }}
                          placement="rightTop"
                          title={
                            <FormattedMessage id="averageRelapseTooltip" />
                          }
                        >
                          <img src="/images/icons/bull.svg" />
                        </Tooltip>
                      </Col>
                      <Col md={12} xl={14}>
                        <span
                          className="roi--label-section"
                          style={{ marginTop: "10px" }}
                        >
                          <FormattedMessage id="averageRelapse" />
                        </span>
                      </Col>
                      {averageRelapseItems.length == 1 && (
                        <Col md={6} xl={8}>
                          <Form.Item
                            name="relapseaverageRelapseadults"
                            rules={[{ validator: dataSuperior0 }]}
                          >
                            <Input
                              type="number"
                              suffix={
                                averageRelapseItems[0].suffix &&
                                averageRelapseItems[0].suffix
                              }
                              prefix={
                                averageRelapseItems[0].prefix &&
                                averageRelapseItems[0].prefix
                              }
                              className={
                                !WorkflowStore.changed.averageRelapseaverage &&
                                "roi--input-default"
                              }
                              onChange={(e) =>
                                onChange("relapseaverageRelapseadults", e)
                              }
                              onBlur={(e) =>
                                onBlur(e, "relapseaverageRelapseadults")
                              }
                            ></Input>
                          </Form.Item>
                        </Col>
                      )}
                    </Row>
                    {averageRelapseItems.length > 1 && (
                      <>
                        <Row style={{ marginTop: "1vh" }}>
                          <Col xl={2} md={2} />
                          <Col xl={14} md={12}>
                            <span className="roi--label-section roi--border-adults">
                              <FormattedMessage id="adults" />
                            </span>
                          </Col>
                          <Col xl={8} md={6}>
                            <Form.Item
                              name="relapseaverageRelapseadults"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                prefix={averageRelapseItems[0].prefix}
                                suffix={averageRelapseItems[0].suffix}
                                className={
                                  !WorkflowStore.changed
                                    .relapseaverageRelapseadults &&
                                  "roi--input-default"
                                }
                                onBlur={(e) =>
                                  onBlur(e, "relapseaverageRelapseadults")
                                }
                                onChange={(e) =>
                                  onChange("relapseaverageRelapseadults", e)
                                }
                                type="number"
                              ></Input>
                            </Form.Item>
                          </Col>
                        </Row>

                        <Row style={{ marginTop: "1vh" }}>
                          <Col xl={2} md={2} />
                          <Col xl={14} md={12}>
                            <span className="roi--label-section roi--border-adults">
                              <FormattedMessage id="teens" />
                            </span>
                          </Col>
                          <Col xl={8} md={6}>
                            <Form.Item
                              name="relapseaverageRelapseteens"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                prefix={averageRelapseItems[1].prefix}
                                suffix={averageRelapseItems[1].suffix}
                                className={
                                  !WorkflowStore.changed
                                    .relapseaverageRelapseteens &&
                                  "roi--input-default"
                                }
                                onBlur={(e) =>
                                  onBlur(e, "relapseaverageRelapseteens")
                                }
                                onChange={(e) =>
                                  onChange("relapseaverageRelapseteens", e)
                                }
                                type="number"
                              ></Input>
                            </Form.Item>
                          </Col>
                        </Row>
                      </>
                    )}
                  </Col>
                  <Col xl={2} md={0} xs={0}></Col>
                </>
              )}
              {/*targetAnnualGrowth.display &&
                targetAnnualGrowth.display != -1 && (
                  <Col xl={10} md={24} xs={24}>
                    <Row>
                      <Col xl={2} md={2}></Col>
                      <Col md={12} xl={14}>
                        <span
                          className="roi--label-section"
                          style={{ marginTop: "10px" }}
                        >
                          <FormattedMessage id="targetAnnualGrowth" />
                        </span>
                      </Col>
                      <Col md={6} xl={8}>
                        <Form.Item
                          name="relapsetargetAnnualGrowth"
                          rules={[{ validator: dataSuperior0 }]}
                        >
                          <Input
                            type="number"
                            suffix={
                              targetAnnualGrowth.suffix &&
                              targetAnnualGrowth.suffix
                            }
                            onChange={(e) => onChange("targetAnnualGrowth", e)}
                            onBlur={(e) => onBlur(e, "targetAnnualGrowth")}
                            className={
                              !WorkflowStore.changed.targetAnnualGrowth &&
                              "roi--input-default"
                            }
                          ></Input>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                          )*/}{" "}
            </Row>{" "}
          </Panel>
        </Collapse>
      );
    } else {
      return "";
    }
  };

  const toDisplayWorkFlow = () => {
    if (
      retention() != "" ||
      relapseElements() != "" ||
      (ToolStore.numbersToTest.w24 + ToolStore.numbersToTest.w25 > 0 &&
        (alignerStatisticsElements() != "" ||
          alignersCost() != "" ||
          alignersTimeSpent() != "")) ||
      (ToolStore.numbersToTest.w28 + ToolStore.numbersToTest.w29 > 0 &&
        (bracesStatisticsElements() != "" ||
          bracesTimeSpent() != "" ||
          bracesCost() != ""))
    ) {
      return true;
    }
    return false || displayAll;
  };

  return (
    <>
      {toDisplayWorkFlow() && (
        <Form
          form={form}
          onChange={() => WorkflowStore.toUpdateWorkflow(form.getFieldsValue())}
        >
          <CollapseComponent
            style={{ marginBottom: "2vh", marginTop: "2vh" }}
            headerText={<FormattedMessage id="workflowTreatment" />}
            classNameHeader="roi--collapse-header-green"
            content={
              WorkflowStore.data != null &&
              (ToolStore.numbersToTest.w24 + ToolStore.numbersToTest.w25 > 0 ||
                ToolStore.numbersToTest.w28 + ToolStore.numbersToTest.w29 > 0 ||
                retention() != "" ||
                displayAll ||
                relapseElements() != "") && (
                <>
                  {displayAll ||
                  ToolStore.numbersToTest.w24 + ToolStore.numbersToTest.w25 >
                    0 ? (
                    <>
                      {alignerStatisticsElements()}
                      {alignersCost()}
                      {alignersTimeSpent()}
                    </>
                  ) : (
                    <></>
                  )}

                  {displayAll ||
                  ToolStore.numbersToTest.w28 + ToolStore.numbersToTest.w29 >
                    0 ? (
                    <>
                      {bracesStatisticsElements()}
                      {bracesCost()}
                      {bracesTimeSpent()}
                    </>
                  ) : (
                    ""
                  )}
                  {retention()}
                  {relapseElements()}
                </>
              )
            }
          ></CollapseComponent>
        </Form>
      )}
    </>
  );
};

export default inject("ToolStore")(observer(WorkflowTreatment));
